<!-- <div style="position: fixed; top: 50%; left: 50%; z-index: 1000; margin-top: -125px; margin-left: -150px" *ngIf="isLottieOn && isBasic">
  <ng-lottie width="300px" height="250px" containerClass="moving-box another-class" [options]="getAnimationOptions"> </ng-lottie>
</div>
<div style="position: fixed; top: 50%; left: 50%; z-index: 1000; margin-top: -125px; margin-left: -150px" *ngIf="isLottieOn && !isBasic">
  <ng-lottie width="300px" height="250px" containerClass="moving-box another-class" [options]="getAnimationOptions"> </ng-lottie>
</div>

<div style="position: fixed; top: 50%; left: 50%; z-index: 1000; margin-top: -125px; margin-left: -150px" *ngIf="iSGetLottieOn && isBasicForm">
  <ng-lottie width="300px" height="250px" containerClass="moving-box another-class" [options]="getAnimationOptions"> </ng-lottie>
</div>
<div style="position: fixed; top: 50%; left: 50%; z-index: 1000; margin-top: -125px; margin-left: -150px" *ngIf="iSGetLottieOn && !isBasicForm">
  <ng-lottie width="300px" height="250px" containerClass="moving-box another-class" [options]="getAnimationOptions"> </ng-lottie>
</div> -->

<mat-sidenav-container class="app__stepper__config sidenav-container relative" style="border-radius: 16px" fullscreen>
  <mat-sidenav
    #templateDrawer
    id="sidenavContainer"
    [mode]="'over'"
    position="end"
    [ngClass]="{
      'app__stepper__config-container overflow-hidden overflow-y-auto visible': isTransactionRegisterOpened,
      'xl:w-[806px] lg:w-[806px] md:[806px] w-[806px] max-[806px]:w-full': isDistributionRegisterOpened,
      'app__common--sidenav--container w-[1017px]': isRolePlayersRegisterOpened
    }"
    [fixedTopGap]="0"
    [disableClose]="true"
    [fixedInViewport]="true"
    (closed)="closeSideNav()"
    [opened]="isTransactionRegisterOpened || isDistributionRegisterOpened || isRolePlayersRegisterOpened || openDataExtraction"
  >
    <div class="w-full h-full px-6" *ngIf="isTransactionRegisterOpened">
      <div>
        <template-transaction-register #transactionRegister [formData]="transactionData" [isInlineComponent]="true"></template-transaction-register>
      </div>
    </div>
    <div *ngIf="openDataExtraction" class="w-full h-full">
      <non-document-form-data-extraction-v2
        [files]="files"
        [categories]="categories"
        [multi_item_extraction_categories]="multi_item_extraction_categories"
        [currentuserId]="currentuserId"
        [currentFormId]="currentFormId"
      ></non-document-form-data-extraction-v2>
    </div>
    <div *ngIf="isDistributionRegisterOpened" class="w-full h-full">
      <distribution-register></distribution-register>
    </div>
    <div *ngIf="isRolePlayersRegisterOpened" class="w-full h-full">
      <manage-role-players-ownership
        [currentRolePlayerData]="currentRolePlayerData"
        [currentFormId]="currentFormId"
        [vault_id]="vault_id"
        [templateId]="templateId"
        [currentuserId]="currentuserId"
      ></manage-role-players-ownership>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <div *ngIf="!isFormSealed" [ngClass]="data?.isLinked ? 'linked-dialog-container' : 'dialog-container'" class="">
      <div *ngIf="screenWidth <= 600">
        <div class="header-mobile-continer">
          <button
            type="button"
            class="close add-close-button"
            style="position: relative; top: 22px"
            data-dismiss="modal"
            (click)="checkFormIsSAvedOrNot()"
          >
            <span class="material-icons icons-close-mobile">close</span>
          </button>
          <div style="display: flex">
            @if(vault_id){
            <button
              class="donwlo-mobile"
              id="tesrrttt"
              *ngIf="!(data?.isintelligent == true || data?.mode == 'add')"
              (click)="!hideSharedAndMoreVertBtn && sharedocument()"
            >
              <span
                style="position: relative; top: 6px"
                class="material-icons material-icons-round"
                [ngClass]="{ 'text-[#BDBDBD]': hideSharedAndMoreVertBtn }"
                >share</span
              >
            </button>

            }@else{
            <button class="donwlo-mobile bg-[#53565B1A]" id="tesrrttt" *ngIf="!(data?.isintelligent == true || data?.mode == 'add')">
              <span
                style="position: relative; top: 6px"
                class="material-icons material-icons-round"
                [ngClass]="{ 'text-[#BDBDBD]': hideSharedAndMoreVertBtn }"
                >share</span
              >
            </button>
            }
            <button
              class="donwlo-mobile"
              id="tesrrttt"
              *ngIf="!(data?.isintelligent == true || data?.mode == 'add') && isDownloadable"
              (click)="downloadAllAttachment()"
            >
              <span style="position: relative; top: 6px" class="material-icons material-icons-round">download</span>
            </button>
            <button
              [class.disable-button-continue]="!documentForm.controls.documentName.valid || disablesingleFielFormValidator"
              *ngIf="mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing && !data.isLinked"
              (click)="mobilecheckValue(documentForm.value)"
              class="mobile-save-continue-button"
            >
              Save
            </button>
            <button
              [class.disable-button-continue]="
                (isOficeWorkSpace ? !documentForm.controls.selectOfficeSaveFolder.valid : !documentForm.controls.selectSaveFolder.valid) ||
                !documentForm.controls.documentName.valid ||
                disablesingleFielFormValidator
              "
              class="mobile-save-continue-button"
              *ngIf="mode == 'edit' && !isRemoveEditSaveSharing"
              (click)="checkValue(documentForm.value) && saveReminderData()"
            >
              Save
            </button>
            <button class="mobile-edit-continue-button" (click)="makedocumentEdit()" *ngIf="mode == 'view' && !isRemoveEditSaveSharing && showButton">
              Edit
            </button>
            <button
              [matMenuTriggerFor]="menuItem"
              (click)="$event.stopPropagation()"
              [disableRipple]="true"
              class="donwlo-mobile"
              id="tesrrttt"
              *ngIf="!hideSharedAndMoreVertBtn && !(data?.isintelligent == true || data?.mode == 'add')"
            >
              <span style="position: relative; top: 6px" class="material-icons material-icons-round">more_vert</span>
            </button>
            <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
              <button mat-menu-item class="popup-menu-item" (click)="openActivityLogModel()">
                <p class="menuitem-text app__menu-item-text">
                  <img class="material-icons material-icons-round menuitem-icon" src="assets/images/activity-log.svg" />
                  Activity Log
                </p>
              </button>

              <button mat-menu-item class="popup-menu-item" (click)="moveAssetItem()">
                <p class="menuitem-text app__menu-item-text">
                  <span class="material-icons material-icons-round menuitem-icon">low_priority</span> Move to
                </p>
              </button>
              <button mat-menu-item class="popup-menu-item" (click)="!security_key ? openCreateShareLinkDialog() : openCannotShareWarningDilaog()">
                <p class="menuitem-text app__menu-item-text">
                  <span class="material-icons material-icons-round menuitem-icon">attachment</span> Get Link
                </p>
              </button>

              <button mat-menu-item class="popup-menu-item" (click)="deleteFileFunction()">
                <p class="menuitem-text app__menu-item-text"><span class="material-icons material-icons-round menuitem-icon">delete</span>Delete</p>
              </button>
            </mat-menu>
          </div>
        </div>
        <div style="display: flex; margin-top: 68px; flex-direction: row; margin-bottom: 12px">
          <form [formGroup]="documentForm" class="document-container">
            <div
              [matTooltip]="documentForm.controls.documentName.value"
              [matTooltipDisabled]="!(sharingMode == true)"
              style="display: flex; justify-content: space-between; align-items: center"
            >
              <div
                [class]="
                  checkIfTestImage(updatedFormUrl || formImage) ? 'form-title-wrapper-testImage form-title-wrapper-image' : 'form-title-wrapper-image'
                "
              >
                <img
                  style="max-height: 44px"
                  *ngIf="updatedFormUrl ?? formImage"
                  [src]="updatedFormUrl ?? formImage"
                  alt="form profile image"
                  [matTooltip]="templateType"
                />
                <span
                  class="material-icons material-icons-round edit-image"
                  mat-icon-button
                  [matMenuTriggerFor]="menuItem2"
                  *ngIf="(updatedFormUrl ?? formImage) && !isRemoveEditSaveSharing"
                  >edit</span
                >
                <mat-menu #menuItem2="matMenu" yPosition="below" xPosition="after" class="popup-menu-panel see-more__popup">
                  <button
                    mat-menu-item
                    class="popup-menu-item menu-btn"
                    (click)="updatedFormUrl ?? formImage ? viewImage(updatedFormUrl ?? formImage) : null"
                    [disabled]="!(updatedFormUrl ?? formImage)"
                  >
                    <p style="margin: auto 0px"><span class="material-icons material-icons-round">visibility</span>View Thumbnail</p>
                  </button>
                  <button mat-menu-item class="popup-menu-item menu-btn" (click)="fileUpload.click()">
                    <p style="margin: auto 0px"><span class="material-icons material-icons-round">image</span>Replace Thumbnail</p>
                    <input
                      type="file"
                      style="display: none"
                      #fileUpload
                      (change)="fileChangeEvent($event)"
                      id="fileUpload"
                      name="fileUpload"
                      accept="image/png,  image/jpeg"
                    />
                  </button>
                  <button
                    mat-menu-item
                    class="popup-menu-item menu-btn"
                    (click)="deleteFormProfileImage()"
                    *ngIf="!checkIfTestImage(updatedFormUrl || formImage)"
                  >
                    <p style="margin: auto 0px" style="color: #eb5757"><span class="material-icons material-icons-round">delete</span>Delete</p>
                  </button>
                </mat-menu>
              </div>
              <div class="flex items-center gap-2 flex-1">
                <input
                  type="text"
                  maxlength="75"
                  style="width: 100%"
                  (keyup.enter)="onEnterName($event)"
                  id="document-form-nameTextbox"
                  [attr.disabled]="mode == 'view' ? '' : null"
                  matTooltip="templateType"
                  [ngClass]="sharingMode == true ? 'no-hover-text-button-for-file' : 'mobile-text-button-for-file'"
                  (focusout)="onFocusOut($event)"
                  (mouseenter)="mobileonFocusEvent($event)"
                  (ngModelChange)="onPercentChange($event)"
                  formControlName="documentName"
                />
                <!-- Star Icon -->
                <div
                  class="star-icon-container flex-shrink-0 cursor-pointer"
                  (click)="toggleDocumentStar()"
                  (mouseenter)="isStarHovering = true"
                  (mouseleave)="isStarHovering = false"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path
                      d="M17.4837 9.88673L14.5295 3.48183C14.321 3.02982 13.6785 3.02982 13.4701 3.48183L10.5158 9.88673C10.4308 10.0709 10.2562 10.1978 10.0547 10.2217L3.05039 11.0522C2.55608 11.1108 2.35756 11.7217 2.72302 12.0597L7.90151 16.8486C8.05046 16.9864 8.11714 17.1916 8.07761 17.3906L6.70298 24.3087C6.60597 24.797 7.12569 25.1746 7.56005 24.9314L13.7148 21.4863C13.8919 21.3872 14.1077 21.3872 14.2847 21.4863L20.4395 24.9314C20.8738 25.1746 21.3935 24.797 21.2965 24.3087L19.9219 17.3906C19.8824 17.1916 19.949 16.9864 20.098 16.8486L25.2765 12.0597C25.6419 11.7217 25.4434 11.1108 24.9491 11.0522L17.9448 10.2217C17.7433 10.1978 17.5687 10.0709 17.4837 9.88673Z"
                      [attr.stroke]="isDocumentStarred ? '#DEA000' : isStarHovering ? '#DEA000' : '#828282'"
                      [attr.fill]="isDocumentStarred ? '#DEA000' : isStarHovering ? 'rgba(222, 160, 0, 0.10)' : 'none'"
                      stroke-width="1.089"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <span *ngIf="showIcon" style="position: relative; top: 12px" class="material-icons"> done </span>
            </div>
          </form>
        </div>
        <div [ngClass]="mode == 'view' ? 'disable-all-input-filed' : 'enable-all-input-filed'" style="margin-right: 18px; width: 148px">
          <!-- <form [formGroup]="documentForm" style="position:relative ;top:14px;" *ngIf="data?.mode == 'edit' || ( !data.isLinked && (!(data?.isintelligent == true || data?.mode == 'add') && !isRemoveEditSaveSharing))"  >
        <mat-form-field
        
                              [ngClass]=" mode == 'view' ? 'disable-all-input-filed-from' : isGeneralSectionResolve ? 'blue-app__medium--height--form' : 'app__medium--height--form'"
          appearance="fill"
          style="width: 100% !important;
        margin-right: 2%;
        margin-left: 1%;"
          class="automtic-form-desing-form-only"
        >
          <mat-label class="automtic-form-desing-lable">
            Status
          </mat-label>
          <mat-select matNativeControl disableOptionCentering
          formControlName="status_progress"
          >
            <mat-option value="up to date" >
              Up To Date          
            </mat-option>
            <mat-option value="need to add" >
              Need To Add
            </mat-option>
            <mat-option value="needs attention" >
              Needs Attention
            </mat-option>
          </mat-select>
        </mat-form-field>
    
      </form> -->
        </div>
      </div>
      <div class="header" *ngIf="screenWidth > 600">
        <div style="display: flex; flex-direction: row" [ngClass]="data?.isLinked ? 'full-widht-linek' : ''" class="w-[60%]">
          <form
            [formGroup]="documentForm"
            style="width: 100%; margin-left: 4px"
            [ngClass]="
              data?.mode != 'edit' && !(!(data?.isintelligent == true || data?.mode == 'add') && !isRemoveEditSaveSharing) ? 'auto-width-form' : ''
            "
          >
            <div [matTooltip]="documentForm.controls.documentName.value" [matTooltipDisabled]="!(sharingMode == true)">
              <div class="disply-icon">
                <div style="border: 1px solid #d3dce8b2; border-radius: 8px; display: flex; width: 100%">
                  <div
                    [class]="
                      checkIfTestImage(updatedFormUrl ?? formImage)
                        ? 'form-title-wrapper-testImage form-title-wrapper-image'
                        : 'form-title-wrapper-image'
                    "
                  >
                    <img
                      style="max-height: 44px"
                      *ngIf="updatedFormUrl ?? formImage"
                      [src]="updatedFormUrl ?? formImage"
                      alt="form profile image"
                      [matTooltip]="templateType"
                    />
                    <span
                      class="material-icons material-icons-round edit-image"
                      mat-icon-button
                      [matMenuTriggerFor]="menuItem"
                      *ngIf="(updatedFormUrl ?? formImage) && !isRemoveEditSaveSharing"
                      >edit</span
                    >
                    <mat-menu #menuItem="matMenu" yPosition="below" xPosition="after" class="popup-menu-panel see-more__popup">
                      <button
                        mat-menu-item
                        class="popup-menu-item menu-btn"
                        (click)="updatedFormUrl ?? formImage ? viewImage(updatedFormUrl ?? formImage) : null"
                        [disabled]="!(updatedFormUrl ?? formImage)"
                      >
                        <p style="margin: auto 0px"><span class="material-icons material-icons-round">visibility</span>View Thumbnail</p>
                      </button>
                      <button mat-menu-item class="popup-menu-item menu-btn" (click)="fileUpload.click()">
                        <p style="margin: auto 0px"><span class="material-icons material-icons-round">image</span>Replace Thumbnail</p>
                        <input
                          type="file"
                          style="display: none"
                          #fileUpload
                          (change)="fileChangeEvent($event)"
                          id="fileUpload"
                          name="fileUpload"
                          accept=".heic, image/heic, image/png,  image/jpeg"
                        />
                      </button>
                      <button
                        mat-menu-item
                        class="popup-menu-item menu-btn"
                        (click)="deleteFormProfileImage()"
                        *ngIf="!checkIfTestImage(updatedFormUrl || formImage)"
                      >
                        <p style="margin: auto 0px" style="color: #eb5757"><span class="material-icons material-icons-round">delete</span>Delete</p>
                      </button>
                    </mat-menu>
                  </div>

                  <div
                    class="w-full flex px-3 items-center gap-2"
                    [ngClass]="
                      enableEditingFormName
                        ? !auto_naming_disabled
                        : (mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing) || !auto_naming_disabled
                        ? 'pointer-events-auto'
                        : 'pointer-events-auto'
                    "
                  >
                    @if(ai_is_upload_Running){
                    <div
                      class="ph-item width-100per loader-body-item"
                      style="margin: 0px; border: 0px; background: transparent; height: 50px; padding: 18px 12px 9px 12px"
                    >
                      <div class="ph-col-12" style="padding: 0px !important">
                        <div class="ph-row">
                          <div class="ph-col-12"></div>
                        </div>
                      </div>
                    </div>
                    }@else{
                    <div class="relative w-full pointer-events-auto" (mouseenter)="isHovering = true" (mouseleave)="isHovering = false">
                      <input
                        class="w-full border-none pr-2"
                        type="text"
                        maxlength="75"
                        (keyup.enter)="onEnterName($event)"
                        id="document-form-nameTextbox"
                        [attr.disabled]="mode == 'view' && !auto_naming_disabled ? '' : null"
                        [ngClass]="[
                          sharingMode == true || !auto_naming_disabled ? 'text-button-for-file' : 'text-button-for-file',
                          data?.isLinked ? 'whiteback-forlinked-form' : ''
                        ]"
                        (focusout)="onFocusOut($event)"
                        (mouseenter)="mobileonFocusEvent($event)"
                        (ngModelChange)="onPercentChange($event)"
                        formControlName="documentName"
                      />
                      <!-- <div *ngIf="isHovering" class="hover-text">
                        {{ templateType }}
                      </div> -->
                    </div>
                    @if(fId == 1 && newAISuggestedFormName){
                    <div
                      class="app__centered-item h-[28px] rounded-[42.3px] bg-[#EBF0FA] hover:bg-[#D0DBF0] active:bg-[#B9C9E9] hover:cursor-pointer gap-[2.5px] px-2 ml-2"
                      (click)="mode != 'view' && openRenameSuggestionDialog(); $event.stopPropagation()"
                    >
                      <img src="assets/images/rename_document_star_icon.svg" alt="AI Rename" class="w-4 h-4" />
                      <span class="app__form--attribute--title text-[10px] font-medium app__gradient--aipowered--text">Rename</span>
                    </div>
                    }
                    <!-- Star Icon -->
                    <div
                      class="star-icon-container flex-shrink-0 cursor-pointer"
                      (click)="toggleDocumentStar()"
                      (mouseenter)="isStarHovering = true"
                      (mouseleave)="isStarHovering = false"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path
                          d="M17.4837 9.88673L14.5295 3.48183C14.321 3.02982 13.6785 3.02982 13.4701 3.48183L10.5158 9.88673C10.4308 10.0709 10.2562 10.1978 10.0547 10.2217L3.05039 11.0522C2.55608 11.1108 2.35756 11.7217 2.72302 12.0597L7.90151 16.8486C8.05046 16.9864 8.11714 17.1916 8.07761 17.3906L6.70298 24.3087C6.60597 24.797 7.12569 25.1746 7.56005 24.9314L13.7148 21.4863C13.8919 21.3872 14.1077 21.3872 14.2847 21.4863L20.4395 24.9314C20.8738 25.1746 21.3935 24.797 21.2965 24.3087L19.9219 17.3906C19.8824 17.1916 19.949 16.9864 20.098 16.8486L25.2765 12.0597C25.6419 11.7217 25.4434 11.1108 24.9491 11.0522L17.9448 10.2217C17.7433 10.1978 17.5687 10.0709 17.4837 9.88673Z"
                          [attr.stroke]="isDocumentStarred ? '#DEA000' : isStarHovering ? '#DEA000' : '#828282'"
                          [attr.fill]="isDocumentStarred ? '#DEA000' : isStarHovering ? 'rgba(222, 160, 0, 0.10)' : 'none'"
                          stroke-width="1.089"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <!-- <img
                      (click)="$event.stopPropagation(); openAutoNaming()"
                      [src]="!auto_naming_disabled ? 'assets/images/autonaming_disable.svg' : 'assets/images/autonaming_enable.svg'"
                      class="mt-3"
                      style="pointer-events: auto"
                    /> -->
                    }
                  </div>
                </div>
                @if(showRightSideSection && !nonVaultOrganizations.includes(currentTemplate?.organization_section)){ @if(vault_id){
                <div
                  class="rounded-lg h-[48px] w-[214px] cursor-pointer ml-2 hover:bg-[#EBF0FA] border border-[#25508E] flex items-center justify-center"
                  style="
                    border: 2px solid #25508e66;
                    background: #ffffff;
                    border-radius: 6px;
                    margin-left: 10px;
                    padding: 12px;
                    min-width: 164px !important;
                  "
                  [matTooltip]="vaultName"
                >
                  <div class="flex items-center w-full relative hover:cursor-pointer gap-2" (click)="isUserHasVault ? moveAssetItem() : null">
                    <img src="assets/images/form_vault.svg" />
                    <span class="text-truncate" [ngClass]="{'text-[#828282]': !isUserHasVault}">
                      {{ vaultName | truncateStrPipe : 17 }}
                    </span>
                  </div>
                </div>
                }@else{
                <div
                  style="padding: 12px; min-width: 164px !important"
                  class="bg-[#53565B1A] flex items-center h-[48px] w-[214px] rounded-lg text-[#898F9E] text-sm font-sans font-semibold leading-[18px] ml-2"
                >
                  <img class="mr-1" src="assets/images/disable-form_vault.svg" />
                  Vault not selected
                </div>
                } }
              </div>
            </div>
          </form>
          <!-- <span class="font-tag-stats w-[216px] mx-1.5 justify-between flex pt-4">
            <file-dashboard-status *ngIf="!notificationLoading" [dashboard_status]="notification_status"> </file-dashboard-status>
            <div
              style="padding: 16px 12px 5px 12px; height: 48px; margin-bottom: 0px; position: relative; top: -9px"
              *ngIf="notificationLoading"
              class="ph-item width-100per loader-body-item"
            >
              <div class="ph-col-12" style="padding: 0px !important">
                <div class="ph-row">
                  <div class="ph-col-12"></div>
                </div>
              </div>
            </div>
          </span> -->
        </div>
        <div class="close-btn" *ngIf="data.isLinked">
          <button style="background-color: transparent; position: relative; top: 12px" (click)="closedialog()" class="web-close-btn">
            <span class="material-icons" style="position: relative">clear</span>
          </button>
        </div>

        <!-- *ngIf="!hideSharedAndMoreVertBtn && !(data?.isintelligent == true || data?.mode == 'add') && !isRemoveEditSaveSharing && !hideShareButton" -->

        <div class="app__persistent--ripple--button flex items-center gap-4" *ngIf="!data.isLinked">
          @if(!!apiIndicators() || apiIndicators() != ''){
          <!-- Add API Indicators -->
          <button
            [ngClass]="{
              'bg-[#DDFFE7] border-[#1AA140]': apiConnectedData(),
              'bg-[#FFF2F2] border-[#EB5757]': !apiConnectedData()
            }"
            class="flex justify-around items-center h-12 w-12 gap-1 rounded-lg border hover:bg-white hover:border-[#5D80C7]"
            id="api-indicator-button"
            (click)="manageApiConnectedData()"
          >
            <img src="assets/images/api-indicator-{{ apiIndicators() }}.svg" width="28px" height="28px" />
            <!-- API Indicators image -->
          </button>
          }@if(nonVaultFormsOrigins.includes(data.origin) && mode !== 'view' && fId != 1) {
          <button
            class="flex justify-around items-center bg-white h-12 gap-1 px-3 rounded border border-[#d3dce8]"
            [ngClass]="{ 'hover:cursor-default': isRemoveEditSaveSharing || hideManageButton }"
            id="tesrrttt"
            (click)="!hideManageButton && !isRemoveEditSaveSharing && managePermissionKey()"
          >
            <img [src]="isRemoveEditSaveSharing ? 'assets/images/permissionDisabledKeyIcon.svg' : 'assets/images/permissionKeyIcon.svg'" width="28px" height="28px" />
          </button>
          } @if(fId == 1) {
          <div
            class="p-[1px] rounded-lg"
            [ngStyle]="{
              background: isRemoveEditSaveSharing
                ? 'linear-gradient(180deg, #C1C2C5 0%, #C1C2C5 55.77%, #C1C2C5 100%)'
                : 'linear-gradient(180deg, #3e75ff 0%, #8400ff 55.77%, #e367ff 100%)'
            }"
            [matTooltip]="!isRemoveEditSaveSharing ? 'Reprocess with AI' : ''"
          >
            <button
              class="flex justify-around items-center h-11 gap-1 px-3 rounded-lg w-12 min-w-[48px] w-full"
              [ngClass]="{ 'bg-[#FAECFF] hover:bg-[#E6D8EB]': !isRemoveEditSaveSharing, 'bg-white border border-[#D3DCE8]': isRemoveEditSaveSharing }"
              [disabled]="isRemoveEditSaveSharing"
              (click)="!isRemoveEditSaveSharing && reTriggerAI()"
            >
              <span
                class="material-icons material-icons-round relative"
                [ngClass]="{ 'text-[#5451FF]': !isRemoveEditSaveSharing, 'text-[#C1C2C5]': isRemoveEditSaveSharing }"
              >
                @if(!analyzeWithAi || ai_is_upload_Running ){ refresh }@else{ more_horiz }
              </span>
            </button>
          </div>
          }
          <button
            [matTooltip]="!isSecurityKeyAdded || !isRemoveEditSaveSharing ? 'This file is not protected with a premium encryption key' : ''"
            style="height: 48px"
            class="flex justify-around items-center bg-white h-12 gap-1 px-3 rounded-lg border border-[#d3dce8] w-12 min-w-[48px]"
            [ngClass]="{'hover:cursor-default': hideSharedAndMoreVertBtn}"
            (click)="!hideManageButton && !isRemoveEditSaveSharing && createPremiumKey()"
          >
            <img
              [src]="
                isSecurityKeyAdded && !hideManageButton && !isRemoveEditSaveSharing
                  ? 'assets/images/lock-enabled.svg'
                  : 'assets/images/lock-disabel.svg'
              "
              width="28px"
              height="28px"
            />
          </button>
          @if(vault_id){
          <button
            *ngIf="(data?.sharedUsers?.length == 0 || !data?.sharedUsers) && !nonVaultFormsOrigins.includes(data.origin)"
            mat-button
            class="flex justify-center items-center bg-white h-12 gap-1 px-3 rounded-lg border border-[#d3dce8] w-12 min-w-[48px]"
            [ngClass]="{'hover:cursor-default': hideSharedAndMoreVertBtn}"
            (click)="mode !== 'view' && !hideSharedAndMoreVertBtn && sharedocument()"
          >
            <span class="material-icons" [ngClass]="this.mode !== 'edit' || this.hideSharedAndMoreVertBtn ? 'text-[#BDBDBD]' : 'text-[#25508E]'">
              share
            </span>
          </button>
          }@else{
          <button
            *ngIf="(data?.sharedUsers?.length == 0 || !data?.sharedUsers) && !nonVaultFormsOrigins.includes(data.origin)"
            mat-button
            class="bg-[#53565B1A] flex justify-center items-center h-12 gap-1 px-3 rounded-lg border border-[#53565B] w-12 min-w-[48px]"
          >
            <span
              class="material-icons"
              [ngClass]="this.mode != 'edit' && this.mode != 'view' && !this.isRemoveEditSaveSharing ? 'text-[#53565B]' : 'text-[#53565B]'"
            >
              share
            </span>
          </button>

          }
          <div
            *ngIf="data?.sharedUsers?.length > 0 && mode !== 'view' && !nonVaultFormsOrigins.includes(data.origin)"
            class="flex items-center"
            (click)="sharedocument()"
          >
            <span class="font-open-sans text-[18px] not-italic font-normal leading-[27px] mr-2 mb-2 text-[#707070] cursor-pointer">Sharing</span>
            <div
              class="shared-users-image__wrapper flex items-center"
              *ngFor="let beneficiary of data.sharedUsers.slice(0, 2); first as isFirst"
              matTooltip="{{ beneficiary.first_name + ' ' + beneficiary.last_name | titlecase }}"
            >
              <div class="shared-image-container" [ngClass]="{ 'is-first': isFirst }">
                <ngx-avatars
                  id="kinnect-avatar"
                  size="24.75"
                  src="{{ beneficiary.profile_image_url }}"
                  name="{{ beneficiary.first_name + ' ' + beneficiary.last_name | titlecase }}"
                  [round]="true"
                  initialsSize="2"
                ></ngx-avatars>
              </div>
            </div>
            <div
              *ngIf="data.sharedUsers.length > 2"
              class="bg-[#EBF0FA] text-k-blue ml-[-20px] w-[30px] h-[30px] mb-[10px] flex justify-center items-center border border-white rounded-full"
              (click)="sharedocument()"
            >
              <span class="font-open-sans text-[12px] not-italic font-normal leading-[18px] whitespace-nowrap">
                + {{ data.sharedUsers.length - 2 }}
              </span>
            </div>
          </div>

          <!-- <div class="flex-center border border-[#D3DCE8] rounded-[8px] px-[10px] py-[0px] gap-[1px] bg-[#FFFFFF] h-[48px] w-[114px]">
            <div>
              <mat-slide-toggle [(ngModel)]="isActive" (click)="onToggleClick($event)" [disabled]="mode === 'view' ? true : false">
              </mat-slide-toggle>
            </div>
            <div class="text-sm font-sans font-normal text-[#707070]">
              <span *ngIf="isActive">Active</span>
              <span *ngIf="!isActive">Inactive</span>
            </div>
          </div> -->

          <button
            mat-button
            class="edit-save-continue-button mr-0"
            id="tesrrttt"
            *ngIf="!(data?.isintelligent == true || data?.mode == 'add') && isDownloadable"
            (click)="downloadAllAttachment()"
          >
            <span class="material-icons material-icons-round">download</span>
          </button>

          <div class="footer" style="display: flex" *ngIf="screenWidth > 600">
            <form class="footer-container" [formGroup]="documentForm">
              <div style="display: flex">
                <!-- <button
              [class.disable-button-continue]="
                isInformationWorkSpace
                  ? false
                  : isOficeWorkSpace
                  ? !documentForm.controls.selectOfficeSaveFolder.valid || !documentForm.controls.documentName.valid || disablesingleFielFormValidator
                  : !documentForm.controls.selectSaveFolder.valid || !documentForm.controls.documentName.valid || disablesingleFielFormValidator
              "
              style="margin-right: 9px; width: 109px; background-color: #25508e; color: white"
              class="edit-save-continue-button"
              *ngIf="mode == 'edit' && !isRemoveEditSaveSharing"
              (click)="checkValue(documentForm.value)"
            >
              Save
            </button>-->
                <button
                  style="margin-right: 9px; width: 109px; height: 44px"
                  class="edit-save-continue-button mr-0"
                  (click)="makedocumentEdit()"
                  *ngIf="mode == 'view' && !isRemoveEditSaveSharing && showButton"
                >
                  Edit
                </button>
                <!-- <add-document-save-dropdown
              *ngIf="!LocationEnable"
              [showInformationtabFolderList]="showInformationtabFolderList"
              [data]="data"
              [hideForloderSelection]="hideForloderSelection"
              [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
              [isOficeWorkSpace]="isOficeWorkSpace"
              [currectMyInformationList]="currectMyInformationList"
              [showEstateList]="showEstateList"
              [fullMyInformationList]="fullMyInformationList"
              [showEstateChildList]="showEstateChildList"
              [showESubstateChildList]="showESubstateChildList"
              [selectSaveFolder]="documentForm.controls['selectSaveFolder'].value"
              [selectOfficeSaveFolder]="documentForm.controls['selectOfficeSaveFolder'].value"
              [isInformationWorkSpace]="isInformationWorkSpace"
              [folderList]="folderList"
              [showFolderList]="showFolderList"
              [subfolderList]="subfolderList"
              [selectedParentLable]="selectedParentLable"
              [fullSubFolderList]="fullSubFolderList"
              [documentForm]="documentForm"
              [EsateList]="EsateList"
              [fulassetList]="fulassetList"
              [showEstateList]="showEstateList"
              [fullOfficeFolderList]="fullOfficeFolderList"
              [markSelectOfficeWorspaceDisable]="markSelectOfficeWorspaceDisable"
              [subchildfolderList]="subchildfolderList"
              [officefolderList]="officefolderList"
              [officesubfolderList]="officesubfolderList"
              [mode]="mode"
            ></add-document-save-dropdown> -->

                <!-- In the div as attr -->
                <!-- matTooltip="Select a folder to save this file in from the
            adjacent dropdown"
                  [matTooltipDisabled]="
                    !(!documentForm.controls.selectSaveFolder.valid || !documentForm.controls.documentName.valid || disablesingleFielFormValidator)
                  " -->
                <div>
                  <!-- In the button ass attr -->
                  <!-- [class.disable-button-continue]="
              LocationEnable
                ? false
                : (isOficeWorkSpace ? !documentForm.controls.selectOfficeSaveFolder.valid : !documentForm.controls.selectSaveFolder.valid) ||
                  !documentForm.controls.documentName.valid ||
                  disablesingleFielFormValidator
            " -->
                </div>
              </div>
            </form>
            <button
              mat-icon-button
              [matMenuTriggerFor]="menuItem"
              class="app__centered-item edit-save-continue-button leading-[14px]"
              id="tesrrttt"
              *ngIf="!(data?.isintelligent == true || data?.mode == 'add')"
              [disabled]="isRemoveEditSaveSharing"
              (click)="$event.stopPropagation()"
              [disableRipple]="true"
            >
              <span class="material-icons" [ngClass]="{ 'text-[#C1C2C5]': isRemoveEditSaveSharing }">more_vert</span>
            </button>
            <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
              <button mat-menu-item class="popup-menu-item" (click)="openActivityLogModel()">
                <p class="menuitem-text app__menu-item-text">
                  <img class="material-icons material-icons-round menuitem-icon" src="assets/images/activity-log.svg" />
                  Activity Log
                </p>
              </button>
              @if(!ShareTypeDataNewFlow){ @if(!nonVaultOrganizations.includes(currentTemplate?.organization_section)){
              <button mat-menu-item class="popup-menu-item" (click)="moveAssetItem()">
                <p class="menuitem-text app__menu-item-text">
                  <span class="material-icons material-icons-round menuitem-icon">low_priority</span> Move to
                </p>
              </button>
              }
              <button mat-menu-item class="popup-menu-item" (click)="!security_key ? openCreateShareLinkDialog() : openCannotShareWarningDilaog()">
                <p class="menuitem-text app__menu-item-text">
                  <span class="material-icons material-icons-round menuitem-icon">attachment</span> Get Link
                </p>
              </button>
              @if(fId == 25){
              <button mat-menu-item class="popup-menu-item" (click)="transformToUser()">
                <p class="menuitem-text app__menu-item-text">
                  <span class="material-icons material-icons-round menuitem-icon">person</span>Transform to User
                </p>
              </button>
              } @if(fId == 2197){
              <button mat-menu-item class="popup-menu-item" (click)="transformToLegalEntity()">
                <p class="menuitem-text app__menu-item-text">
                  <img src="assets/images/template-register/entity.svg" class="material-icons material-icons-round menuitem-icon" />Transform to Legal
                  Entity
                </p>
              </button>
              }
              <button mat-menu-item class="popup-menu-item" (click)="deleteFileFunction()">
                <p class="menuitem-text app__menu-item-text text-[#EB5757]">
                  <span class="material-icons material-icons-round menuitem-icon text-[#EB5757]">delete</span>Delete
                </p>
              </button>
              }
            </mat-menu>
          </div>

          <div
            class="web-close-icon"
            *ngIf="
              data?.mode == 'edit' || (!(data?.isintelligent == true || data?.mode == 'add' || data?.mode == 'edit') && !isRemoveEditSaveSharing)
            "
          >
            <button (click)="checkFormIsSAvedOrNot()" class="web-close-btn" style="position: relative; left: 4px; top: 4px">
              <span class="material-icons" style="position: relative">clear</span>
            </button>
          </div>
          <div class="web-close-icon" *ngIf="isRemoveEditSaveSharing">
            <button (click)="closedialog()" class="web-close-btn">
              <span class="material-icons" style="position: relative">clear</span>
            </button>
          </div>
        </div>
      </div>

      <div
        class="main-area"
        [ngClass]="{  'linked-main-area':data?.isLinked,
       'flex-col':isIpadOrTabletScreenWidth(),
       }"
      >
        <div
          class="overflow-y-auto"
          [ngClass]="{
            'linked-left-area': data?.isLinked,
            'left-area': !data?.isLinked,
            'w-full': isIpadOrTabletScreenWidth()
          }"
        >
          @if(isIpadOrTabletScreenWidth()){
          <div class="mr-[24px]">
            <ng-container *ngTemplateOutlet="vaultSelectionForm"></ng-container>
            @if(!isRemoveEditSaveSharing){
            <ng-container *ngTemplateOutlet="templateTeStatusTemplate"></ng-container>
            }
          </div>
          }
          <div>
            @if(ai_is_upload_Running){
            <label class="app__template--linked--header mb-2 flex items-center gap-2"
              >General Information
              <img
                src="/assets/images/high-priority-flag-icon.svg"
                matTooltip="High Priority Item"
                matTooltipPosition="above"
                alt="High Priority Item"
              />
            </label>

            <div style="width: 100%">
              <div class="ph-col-12" style="padding: 0px !important"></div>
              <div class="flex loader-body" style="width: 100%">
                <div class="ph-item width-100per loader-body-item" style="border: 0px !important; height: auto">
                  <div class="ph-col-12" style="padding: 0px !important; margin-top: 24px">
                    <div class="ph-row">
                      <div class="ph-col-4" style="height: 12px"></div>
                    </div>
                    <div class="ph-row" style="padding: 0px !important; margin-top: 24px">
                      <div class="ph-col-6" style="height: 30px"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4" style="height: 30px"></div>
                    </div>
                    <div class="ph-row" style="padding: 0px !important; margin-top: 24px">
                      <div class="ph-col-2" style="height: 30px"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-2" style="height: 30px"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-2" style="height: 30px"></div>
                    </div>
                  </div>
                  <div class="ph-col-12" style="padding: 0px">
                    <div class="ph-row" style="margin-top: 25px">
                      <div class="ph-col-4" style="height: 12px; margin-bottom: 24px"></div>
                      <div class="ph-col-8 empty"></div>

                      <div class="ph-col-6" style="height: 30px"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4" style="height: 30px; margin-top: 12px"></div>
                      <div class="ph-col-2" style="height: 30px; margin-top: 12px"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-2" style="height: 30px; margin-top: 12px"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4" style="height: 30px; margin-top: 12px"></div>
                      <div class="ph-col-12" style="height: 30px; margin-top: 12px"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }@else{
            <form
              [formGroup]="documentForm"
              [hidden]="isFormSealed"
              style="height: auto; flex-direction: column"
              [ngClass]="data?.isLinked ? 'whiteback-forlinked-form' : 'formmain-auto'"
            >
              <div [ngStyle]="!isIpadOrTabletScreenWidth() ? { margin: '0px 3% 0 0' } : {}">
                @if(fId == 1 && files.length && !HideAddinationInfo){
                <form-attachment
                  [files]="files"
                  [currentTemplate]="currentTemplate"
                  [currentuserId]="currentuserId"
                  [currentFormId]="currentFormId"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  (reloadFileEventEmitter)="reloadFileEventEmitter($event)"
                  (locationTagEventEmitter)="manageLocation($event)"
                >
                </form-attachment>
                <div class="bg-white border border-solid border-[#D3DCE8] rounded-lg pt-4 pb-5 px-5 mt-5">
                  <span class="app__form--attribute--title text-base text-[#010818] mb-4 block">Document Information</span>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="flex flex-col justify-center h-[48px] border border-solid border-[#B1ACB066] rounded bg-white py-2 px-3">
                      <span class="app__form--attribute--title font-semibold text-[8px] leading-tight text-[#25508E] mb-1">Sent By</span>
                      <span class="app__form--attribute--title font-normal text-[12px] leading-normal text-[#828282] truncate">{{
                        files[0]?.from_name || files[0]?.from_email || '---'
                      }}</span>
                    </div>

                    <div class="flex flex-col justify-center h-[48px] border border-solid border-[#B1ACB066] rounded bg-white py-2 px-3">
                      <span class="app__form--attribute--title font-semibold text-[8px] leading-tight text-[#25508E] mb-1">Size</span>
                      <span class="app__form--attribute--title font-normal text-[12px] leading-normal text-[#333333]">{{
                        files[0]?.size | sizeConvertor
                      }}</span>
                    </div>

                    <div class="flex flex-col justify-center h-[48px] border border-solid border-[#B1ACB066] rounded bg-white py-2 px-3">
                      <span class="app__form--attribute--title font-semibold text-[8px] leading-tight text-[#25508E] mb-1">File Type</span>
                      <span class="app__form--attribute--title font-normal text-[12px] leading-normal text-[#828282]">{{
                        files[0]?.file_type || '---'
                      }}</span>
                    </div>

                    <div class="flex flex-col justify-center h-[48px] border border-solid border-[#B1ACB066] rounded bg-white py-2 px-3">
                      <span class="app__form--attribute--title font-semibold text-[8px] leading-tight text-[#25508E] mb-1">Upload Date</span>
                      <span class="app__form--attribute--title font-normal text-[12px] leading-normal text-[#828282]">{{
                        files[0]?.created_at | date : 'MMM d, yyyy'
                      }}</span>
                    </div>
                  </div>
                </div>
                }@else{
                <div *ngIf="(!arrayItems?.length && !formIsLoaded) || HideAddinationInfo" class="loader-container mr-[24px]">
                  <div style="width: 100%">
                    <div class="ph-col-12" style="padding: 0px !important"></div>
                    <div class="flex loader-body" style="width: 100%">
                      <div class="ph-item width-100per loader-body-item" style="border: 0px !important; height: auto">
                        <div class="ph-col-12" style="padding: 0px !important; margin-top: 24px">
                          <div class="ph-row">
                            <div class="ph-col-4" style="height: 12px"></div>
                          </div>
                          <div class="ph-row" style="padding: 0px !important; margin-top: 24px">
                            <div class="ph-col-6" style="height: 30px"></div>
                            <div class="ph-col-2 empty"></div>
                            <div class="ph-col-4" style="height: 30px"></div>
                          </div>
                          <div class="ph-row" style="padding: 0px !important; margin-top: 24px">
                            <div class="ph-col-2" style="height: 30px"></div>
                            <div class="ph-col-2 empty"></div>
                            <div class="ph-col-2" style="height: 30px"></div>
                            <div class="ph-col-2 empty"></div>
                            <div class="ph-col-2" style="height: 30px"></div>
                          </div>
                        </div>
                        <div class="ph-col-12" style="padding: 0px">
                          <div class="ph-row" style="margin-top: 25px">
                            <div class="ph-col-4" style="height: 12px; margin-bottom: 24px"></div>
                            <div class="ph-col-8 empty"></div>

                            <div class="ph-col-6" style="height: 30px"></div>
                            <div class="ph-col-2 empty"></div>
                            <div class="ph-col-4" style="height: 30px; margin-top: 12px"></div>
                            <div class="ph-col-2" style="height: 30px; margin-top: 12px"></div>
                            <div class="ph-col-2 empty"></div>
                            <div class="ph-col-2" style="height: 30px; margin-top: 12px"></div>
                            <div class="ph-col-2 empty"></div>
                            <div class="ph-col-4" style="height: 30px; margin-top: 12px"></div>
                            <div class="ph-col-12" style="height: 30px; margin-top: 12px"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
              <div class="stepper1margin app__select--text--size" [ngClass]="mode == 'view' ? 'disable-all-input-filed' : 'enable-all-input-filed'">
                <div
                  [ngClass]="{ 'hide-section-for-document-from': fId == 1 }"
                  formArrayName="dynamicFieldsForm"
                  style="border-radius: 0.5rem; justify-content: space-between; padding: 16px; border: 1px solid rgba(83, 86, 91, 0.14)"
                  class="flex-container mobile-form-container margin-top-custom bg-white"
                >
                  <label *ngIf="arrayItems?.length" class="app__template--linked--header mb-2 flex items-center gap-2"
                    >{{ arrayItems[0].label }}
                    @if(!generalInformationHasAnyValue){
                    <img
                      src="/assets/images/high-priority-flag-icon.svg"
                      class="w-[28.144px] h-[28.144px]"
                      matTooltip="High Priority Item"
                      matTooltipPosition="above"
                      alt="High Priority Item"
                    />
                    }
                  </label>
                  <ng-container *ngFor="let arrayItem of arrayItems; let i = index">
                    <div
                      [formGroupName]="'0'"
                      [ngStyle]="{ width: arrayItem?.width ? (arrayItem?.width == '99%' ? '100%' : arrayItem?.width) : '100%' }"
                      class="dynamic-form-field-container"
                    >
                      <label
                        *ngIf="arrayItem?.type == 'Section' && arrayItem.label != 'General Information' && arrayItem.label != 'Description'"
                        style="color: #25508e"
                        class="app__template--linked--header mb-2"
                        >{{ arrayItem.label }}
                        <span
                          *ngIf="arrayItem?.label"
                          matTooltip="Fields displayed are based on the selected template."
                          class="material-icons info-icon-custom"
                          >info</span
                        >
                      </label>
                      <div *ngIf="arrayItem?.type == 'MultiPleDropDown'" class="w-full mt-3">
                        <mat-form-field
                          appearance="fill"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          class="automtic-form-desing-form-only"
                          style="width: 100% !important; position: relative; left: -3px"
                          id="typeclassinput"
                        >
                          <mat-label class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                          <mat-select disableOptionCentering class="example-panel" [formControlName]="arrayItem?.formControlName" matNativeControl>
                            <mat-option [value]="item?.value" class="hide-check-box" *ngFor="let item of arrayItem?.data">
                              {{ item?.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div *ngIf="arrayItem?.type == 'email'" class="w-full mt-3">
                        <mat-form-field
                          appearance="fill"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          style="width: 100% !important"
                          class="automtic-form-desing-form-only"
                        >
                          <mat-label *ngIf="arrayItem?.label" class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                          <input
                            matInput
                            [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                            type="email"
                            [formControlName]="arrayItem?.formControlName"
                          />
                        </mat-form-field>
                      </div>
                      <div *ngIf="arrayItem?.type == 'text'" class="w-full mt-3">
                        <mat-form-field
                          *ngIf="arrayItem?.label"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          appearance="fill"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          style="width: 100% !important"
                          class="automtic-form-desing-form-only {{
                            isLoadingTrimData && arrayItem?.label.includes('Trim') ? 'is-loading-trim-data' : ''
                          }}"
                        >
                          <mat-label class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                          <input
                            matInput
                            [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                            *ngIf="arrayItem?.makeEyeField"
                            [type]="arrayItem.setDefaultEyeField && mode != 'view' ? 'text' : 'text'"
                            [ngClass]="{ 'mask-input-text': arrayItem.setDefaultEyeField && mode != 'view' }"
                            [formControlName]="arrayItem?.formControlName"
                          />
                          <input
                            matInput
                            [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                            *ngIf="!arrayItem?.makeEyeField"
                            [formControlName]="arrayItem?.formControlName"
                            (blur)="arrayItem?.formControlName.includes('automobile') ? onFieldBlur(arrayItem?.formControlName) : null"
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            *ngIf="arrayItem?.makeEyeField"
                            [disabled]="mode == 'view'"
                            (click)="arrayItem.setDefaultEyeField = !arrayItem.setDefaultEyeField"
                            [attr.aria-label]="'Hide password'"
                          >
                            <mat-icon>{{ arrayItem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                          </button>

                          <button class="p-0" mat-icon-button *ngIf="isLoadingTrimData && arrayItem?.label.includes('Trim')" matSuffix>
                            <mat-icon class="w-[14px]"><mat-spinner style="color: #25508e" class="w-[14px]" [diameter]="24"></mat-spinner></mat-icon>
                          </button>
                        </mat-form-field>
                      </div>
                      <div *ngIf="arrayItem?.type == 'number'" class="w-full mt-3">
                        <mat-form-field
                          appearance="fill"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          style="width: 100% !important"
                          class="automtic-form-desing-form-only"
                        >
                          <mat-label *ngIf="arrayItem?.label" class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                          <input
                            matInput
                            id="target"
                            [type]="arrayItem.setDefaultEyeField && mode != 'view' ? 'text' : 'text'"
                            [ngClass]="{ 'mask-input-text': arrayItem.setDefaultEyeField && mode != 'view' }"
                            [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                            pattern="\d+"
                            [formControlName]="arrayItem?.formControlName"
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            *ngIf="arrayItem?.makeEyeField"
                            [disabled]="mode == 'view'"
                            (click)="arrayItem.setDefaultEyeField = !arrayItem.setDefaultEyeField"
                            [attr.aria-label]="'Hide password'"
                          >
                            <mat-icon>
                              {{ arrayItem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                          </button>
                        </mat-form-field>
                      </div>
                      <div *ngIf="arrayItem?.type == 'date'" class="w-full mt-3">
                        <reusable-date-input
                          [title]="arrayItem.label"
                          [controlName]="arrayItem?.formControlName"
                          [value]="documentForm.controls['dynamicFieldsForm'].value[0][arrayItem?.formControlName]"
                          (dateChangeEmitter)="handleDateChange($event, arrayItem?.formControlName)"
                          (changeEmitter)="handleDateChange2($event, arrayItem?.formControlName)"
                          [hasClassTruncate]="true"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClassStyle]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          style="width: 100% !important; display: contents"
                          [classStyle]="'automtic-form-desing-form-only truncate-date-form-input'"
                          [isRequired]="arrayItem?.isRequired"
                          [labelClass]="'truncate-label'"
                        >
                        </reusable-date-input>
                      </div>
                      <div *ngIf="arrayItem?.type == 'select'" class="w-full mt-3">
                        @if(arrayItem.label == 'State' || arrayItem.label == 'Country') {
                        <mat-form-field
                          appearance="fill"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          style="width: 100% !important"
                          class="automtic-form-desing-form-only"
                        >
                          <mat-label class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                          <input
                            type="text"
                            matInput
                            [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                            [formControlName]="arrayItem?.formControlName"
                            [matAutocomplete]="auto2"
                          />
                          <mat-autocomplete #auto2="matAutocomplete">
                            @if (arrayItem?.options.length) {
                            <mat-option [value]="item?.value" class="hide-check-box" *ngFor="let item of arrayItem?.options">
                              {{ item?.label }}
                            </mat-option>
                            }
                          </mat-autocomplete>
                          @if (user.state) {
                          <div matSuffix [style.cursor]="mode == 'view' ? 'default' : 'pointer'" (click)="mode != 'view' && (user.state = '')">
                            <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                          </div>
                          }
                        </mat-form-field>
                        }@else {
                        <mat-form-field
                          appearance="fill"
                          [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          style="width: 100% !important"
                          class="automtic-form-desing-form-only"
                        >
                          <mat-label class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                          <mat-select
                            [ngClass]="{ 'example-panel-select': mode == 'view' }"
                            matNativeControl
                            disableOptionCentering
                            [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                            [formControlName]="arrayItem?.formControlName"
                            (selectionChange)="arrayItem?.formControlName.includes('automobile') ? onFieldBlur(arrayItem?.formControlName) : null"
                          >
                            <mat-option [value]="item?.value" class="hide-check-box" *ngFor="let item of arrayItem?.options">
                              {{ item?.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        }
                      </div>
                      <div *ngIf="arrayItem?.type == 'largeText' && arrayItem?.label != 'Description'" class="w-full mt-3">
                        <ngx-editor-field
                          [mode]="mode"
                          (bookTitleCreated)="onBookAdded($event)"
                          [arrayItem]="arrayItem"
                          [formControlValue]="documentForm.controls.dynamicFieldsForm.controls[0].controls[arrayItem?.formControlName].value"
                        >
                        </ngx-editor-field>
                      </div>
                      <div *ngIf="arrayItem?.type == 'checkBox'" style="height: 45.93px !important; padding-top: 10px">
                        <mat-checkbox
                          class="automatic-form-checkbox"
                          [ngClass]="
                            mode == 'view'
                              ? 'disable-all-input-filed-from'
                              : isGeneralSectionResolve
                              ? 'blue-app__medium--height--form'
                              : 'app__medium--height--form'
                          "
                          [formControlName]="arrayItem?.formControlName"
                        >
                          <mat-label class="automtic-form-desing-lable">
                            {{ arrayItem.label }}
                            <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                          </mat-label>
                        </mat-checkbox>
                      </div>
                    </div>
                    <div
                      class="flex-container mobile-form-container"
                      style="padding: 0px; width: 100% !important"
                      *ngIf="arrayItem?.type == 'MultiPleDropDown'"
                    >
                      <div [formGroupName]="'0'" style="width: 100%; display: flex; flex-wrap: wrap" *ngFor="let item of arrayItem?.data">
                        <div *ngFor="let childitem of item?.template" [ngStyle]="{ width: childitem?.width ? childitem?.width : '100%' }">
                          <div
                            *ngIf="
                              documentForm['controls']['dynamicFieldsForm']['controls'][0]['controls'][arrayItem?.formControlName].value ==
                              item?.value
                            "
                            class="dynamic-form-field-container"
                          >
                            <div *ngIf="childitem?.type == 'email'" class="w-full mt-3">
                              <mat-form-field
                                appearance="fill"
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  type="email"
                                  [formControlName]="childitem?.formControlName"
                                />
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'text'" class="w-full mt-3">
                              <mat-form-field
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                *ngIf="childitem?.label"
                                appearance="fill"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input
                                  matInput
                                  *ngIf="childitem?.makeEyeField"
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  [type]="childitem.setDefaultEyeField && mode != 'view' ? 'text' : 'text'"
                                  [ngClass]="{ 'mask-input-text': childitem.setDefaultEyeField && mode != 'view' }"
                                  [formControlName]="childitem?.formControlName"
                                />
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  *ngIf="!childitem?.makeEyeField"
                                  [formControlName]="childitem?.formControlName"
                                />
                                <button
                                  mat-icon-button
                                  matSuffix
                                  *ngIf="childitem?.makeEyeField"
                                  [disabled]="mode == 'view'"
                                  (click)="childitem.setDefaultEyeField = !childitem.setDefaultEyeField"
                                  [attr.aria-label]="'Hide password'"
                                >
                                  <mat-icon>{{ childitem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                                </button>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'date'" class="w-full mt-3">
                              <mat-form-field
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                appearance="fill"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input matInput (click)="mode != 'view' && dp3.open()" [matDatepicker]="dp3" [formControlName]="childitem?.formControlName" />
                                <mat-datepicker-toggle [disabled]="mode == 'view'" matSuffix [for]="dp3"></mat-datepicker-toggle>
                                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'number'" class="w-full mt-3">
                              <mat-form-field
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                appearance="fill"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  *ngIf="childitem?.makeEyeField"
                                  id="target"
                                  pattern="\d+"
                                  type="text"
                                  [type]="childitem.setDefaultEyeField ? 'text' : 'text'"
                                  [ngClass]="{ 'mask-input-text': childitem.setDefaultEyeField }"
                                  [formControlName]="childitem?.formControlName"
                                />
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  *ngIf="!childitem?.makeEyeField"
                                  id="target"
                                  pattern="\d+"
                                  type="text"
                                  [formControlName]="childitem?.formControlName"
                                />
                                <button
                                  mat-icon-button
                                  matSuffix
                                  *ngIf="childitem?.makeEyeField"
                                  [disabled]="mode == 'view'"
                                  (click)="childitem.setDefaultEyeField = !childitem.setDefaultEyeField"
                                  [attr.aria-label]="'Hide password'"
                                >
                                  <mat-icon>{{ childitem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                                </button>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'select'" class="automtic-form-desing-form-only w-full mt-4">
                              <mat-form-field
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                appearance="fill"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <mat-select
                                  [ngClass]="{ 'example-panel-select': mode == 'view' }"
                                  matNativeControl
                                  disableOptionCentering
                                  [formControlName]="childitem?.formControlName"
                                >
                                  <mat-option [value]="item?.value" class="hide-check-box" *ngFor="let item of childitem?.options">
                                    {{ item?.label }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'largeText'" class="w-full mt-3">
                              <mat-form-field
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                appearance="fill"
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                style="width: 100% !important"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <textarea
                                  matInput
                                  maxlength="1500"
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  cdkAutosizeMinRows="5"
                                  style="overflow: hidden; height: auto !important; min-height: 16px !important"
                                  matTextareaAutosize
                                  [formControlName]="childitem?.formControlName"
                                >
                                </textarea>
                                <!-- <div class="form-row__description">
                                                        1/15003
                                                    </div> -->
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'checkBox'" style="height: 45.93px !important; padding-top: 10px">
                              <mat-checkbox class="automatic-form-checkbox" [formControlName]="childitem?.formControlName">
                                <mat-label class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                              </mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  @if(showCopyDataButton){ @if(this.apiIndicators() == 'zillow'){
                  <div class="w-full">
                    <div
                      class="connect-with-dataType-frame"
                      [ngClass]="{
                        'connect-with-dataType-frame-active': isDocumentFormValid() && !isConnectingWithDataType && !isReconnectingWithDataType && mode != 'view',
                        'connect-with-dataType-frame-inactive hover:cursor-default':
                          isDocumentFormValid() == false && !isConnectingWithDataType && !isReconnectingWithDataType || mode == 'view',
                        'connecting-with-dataType-frame': isConnectingWithDataType || isReconnectingWithDataType,
                      }"
                      (click)="
                        mode != 'view' &&
                          !isConnectingWithDataType &&
                          isDocumentFormValid() == true &&
                          (isReconnectingWithDataType ? reconnectZillow() : connectZillow())
                      "
                    >
                      <div style="display: flex; align-items: center">
                        @if(isConnectingWithDataType){
                        <mat-spinner [diameter]="14"></mat-spinner>
                        }@else if(isReconnectingWithDataType){
                        <img src="/assets/images/documentPage/zillow-reconnect.svg" alt="zillow-reconnect" />
                        }@else{ @if(isDocumentFormValid() && !isConnectingWithDataType && !isReconnectingWithDataType){<img
                          src="/assets/images/documentPage/zillow-active-state.svg"
                          alt="zillow-active-state"
                        />
                        } @else if(!isDocumentFormValid() && !isConnectingWithDataType && !isReconnectingWithDataType){<img
                          src="/assets/images/documentPage/zillow-inActive-state.svg"
                          alt="zillow-inActive-state"
                        />
                        } }
                      </div>
                      @if(isConnectingWithDataType){ Connecting with Zillow }@else if(isReconnectingWithDataType){ Reconnect }@else{ Connect with
                      Zillow }
                    </div>

                    @if((isDocumentFormValid() == false && !isConnectingWithDataType) || isReconnectingWithDataType){
                    <div class="connect-with-dataType-info-message mt-2" [ngStyle]="{ color: isReconnectingWithDataType ? '#EB5757' : '#25508E' }">
                      <!-- <span
                        class="material-symbols-outlined text-[16px] h-[16px] w-[16px]"
                        [ngStyle]="{ color: isReconnectingWithDataType ? '#EB5757' : '#25508E' }"
                      >
                        info
                      </span> -->
                      <div>
                        @if(isReconnectingWithDataType){ Unable to connect. Please update property information & try again. }@else{ Enter Street
                        Address, City, State & Zip }
                      </div>
                    </div>
                    }
                  </div>
                  } @if(this.apiIndicators() == 'vb'){
                  <div class="w-full">
                    <div
                      class="connect-with-dataType-frame"
                      [ngClass]="{
                        'connect-with-dataType-frame-active':
                          isVehicleDatabaseFormValid() && !isConnectingWithDataType && !isReconnectingWithDataType && mode != 'view',
                        'connect-with-dataType-frame-inactive hover:cursor-default':
                          isVehicleDatabaseFormValid() == false && !isConnectingWithDataType && !isReconnectingWithDataType || mode == 'view',
                        'connecting-with-dataType-frame': isConnectingWithDataType || isReconnectingWithDataType,
                      }"
                      (click)="
                        mode != 'view' &&
                          !isConnectingWithDataType &&
                          isVehicleDatabaseFormValid() == true &&
                          (isReconnectingWithDataType ? reconnectVehicleDatabase() : connectVehicleDatabase())
                      "
                    >
                      <div style="display: flex; align-items: center">
                        @if(isConnectingWithDataType){
                        <mat-spinner [diameter]="14"></mat-spinner>
                        }@else{<img src="/assets/images/documentPage/vehicle-database.svg" alt="vehicle-database" />
                        }
                      </div>
                      @if(isConnectingWithDataType){ Connecting with Vehicle Database }@else if(isReconnectingWithDataType){ Reconnect }@else{ Connect
                      with Vehicle Database }
                    </div>

                    @if((isVehicleDatabaseFormValid() == false && !isConnectingWithDataType) || isReconnectingWithDataType){
                    <div
                      class="connect-with-dataType-info-message mt-2"
                      [ngStyle]="{ color: isTrimOptionsNotAvailable || isReconnectingWithDataType ? '#EB5757' : '#25508E' }"
                    >
                      <!-- <span
                        class="material-symbols-outlined text-[16px] h-[16px] w-[16px]"
                        [ngStyle]="{ color: isTrimOptionsNotAvailable || isReconnectingWithDataType ? '#EB5757' : '#25508E' }"
                      >
                        info
                      </span> -->
                      <div>
                        <!-- @if(isTrimOptionsNotAvailable){ Unable to find Trim Options. Please adjust Make, Model & Year, if possible. } @else
                        if(isReconnectingWithDataType){ Unable to connect. Please update vehicle information & try again. } @else{ Enter Make, Model,
                        Year, Trim & Condition } -->
                      </div>
                    </div>
                    }
                  </div>
                  } }
                </div>
                @if(fId != 1 && currentFormId && !HideAddinationInfo && arrayItems?.length && (ai_type === 'complex' || ai_type === 'simple')){
                <div class="mt-6 mb-[24px]">
                  <non-document-summary
                    [currentTemplate]="currentTemplate"
                    [currentFormId]="currentFormId"
                    [vault_id]="vault_id"
                    [currentuserId]="currentuserId"
                    [linkDocuments]="linkDocuments"
                    [isComplexTemplateAi]="ai_type == 'complex' ? true : false"
                    [documentName]="documentForm?.controls?.documentName?.value"
                  ></non-document-summary>
                </div>
                }
                <div
                  formArrayName="beneFicaryForm"
                  style="justify-content: space-between; width: 100%; padding: 0px"
                  class="flex-container mobile-form-container"
                  *ngFor="let arrayItem of beneFicaryForm; let i = index"
                >
                  <h3
                    *ngIf="
                      beneFicaryForm?.length >= 1 &&
                      (mode == 'view' || isRemoveEditSaveSharing ? templateListCounter(i, arrayItem?.formControlName) != 0 : true)
                    "
                    class="title"
                    style="margin-bottom: 12px; width: 100% !important"
                  >
                    {{ arrayItem.SectionTitle }}
                    <span class="material-icons info-icon-custom">info</span>
                  </h3>
                  <div [formArrayName]="i" style="width: 100% !important">
                    <div [formArrayName]="arrayItem?.formControlName" class="remove-maring-right-mobile" style="margin-right: -11px">
                      <div *ngFor="let skill of templateList(i, arrayItem?.formControlName).controls; let skillIndex = index">
                        <p id="beneficary-section" style="font-size: 14; font-weight: 400">
                          {{ arrayItem.Singularname }} No. {{ skillIndex + 1 }}
                          <span
                            *ngIf="mode != 'view' && !isRemoveEditSaveSharing"
                            (click)="removeBeneficary(arrayItem.formControlName, i, skillIndex)"
                            style="position: relative; top: 3px"
                            class="material-icons dust-bin-icon"
                            >delete</span
                          >
                        </p>
                        <div [formGroupName]="skillIndex" class="mobile-form-container flex-container" style="margin: 0px -20px 0px -20px !important">
                          <div
                            *ngFor="let childitem of arrayItem?.template"
                            class="dynamic-form-field-container"
                            [ngStyle]="{ width: childitem?.width ? (childitem?.width == '100%' ? '99%' : childitem?.width) : '99%' }"
                          >
                            <label *ngIf="childitem?.type == 'Section'" style="color: #25508e" class="app__template--linked--header mb-2"
                              >{{ childitem.label }}
                            </label>

                            <div *ngIf="childitem?.type == 'text'" class="w-full mt-3">
                              <mat-form-field
                                *ngIf="childitem?.label"
                                appearance="fill"
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                style="width: 100% !important"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  *ngIf="childitem?.makeEyeField"
                                  [type]="childitem.setDefaultEyeField && mode != 'view' ? 'text' : 'text'"
                                  [formControlName]="childitem?.formControlName"
                                  [ngClass]="{ 'mask-input-text': childitem.setDefaultEyeField && mode != 'view' }"
                                />
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  *ngIf="!childitem?.makeEyeField"
                                  [formControlName]="childitem?.formControlName"
                                />
                                <button
                                  mat-icon-button
                                  matSuffix
                                  *ngIf="childitem?.makeEyeField"
                                  [disabled]="mode == 'view'"
                                  (click)="childitem.setDefaultEyeField = !childitem.setDefaultEyeField"
                                  [attr.aria-label]="'Hide password'"
                                >
                                  <mat-icon>{{ childitem?.setDefaultEyeField ? 'visibility_off' : 'visibility' }} </mat-icon>
                                </button>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'date'" class="w-full mt-3">
                              <mat-form-field
                                appearance="fill"
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                style="width: 100% !important"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input matInput [matDatepicker]="dp3" (click)="mode != 'view' && dp3.open()" [formControlName]="childitem?.formControlName" />
                                <mat-datepicker-toggle [disabled]="mode == 'view'" matSuffix [for]="dp3"></mat-datepicker-toggle>
                                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'number'" class="w-full mt-3">
                              <mat-form-field
                                appearance="fill"
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                style="width: 100% !important"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  id="target"
                                  pattern="\d+"
                                  type="text"
                                  [formControlName]="childitem?.formControlName"
                                />
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'select'" class="w-full mt-3">
                              <mat-form-field
                                appearance="fill"
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                style="width: 100% !important"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <mat-select
                                  [ngClass]="{ 'example-panel-select': mode == 'view' }"
                                  matNativeControl
                                  disableOptionCentering
                                  [formControlName]="childitem?.formControlName"
                                >
                                  <mat-option [value]="item?.value" class="hide-check-box" *ngFor="let item of childitem?.options">
                                    {{ item?.label }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'email'" class="w-full mt-3">
                              <mat-form-field
                                appearance="fill"
                                style="width: 100% !important"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <input
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  type="email"
                                  [formControlName]="childitem?.formControlName"
                                />
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'largeText'" class="w-full mt-3">
                              <mat-form-field
                                appearance="fill"
                                style="width: 100% !important"
                                [ngClass]="
                                  mode == 'view'
                                    ? 'disable-all-input-filed-from'
                                    : isGeneralSectionResolve
                                    ? 'blue-app__medium--height--form'
                                    : 'app__medium--height--form'
                                "
                                [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                                class="automtic-form-desing-form-only"
                              >
                                <mat-label *ngIf="childitem?.label" class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                                <textarea
                                  matInput
                                  [placeholder]="mode == 'view' ? '---' : childitem?.placeholder"
                                  maxlength="1500"
                                  cdkAutosizeMinRows="5"
                                  style="overflow: hidden; height: auto !important; min-height: 16px !important"
                                  matTextareaAutosize
                                  [formControlName]="childitem?.formControlName"
                                >
                                </textarea>
                                <!-- <div class="form-row__description">
                                                    1/15000
                                                </div> -->
                              </mat-form-field>
                            </div>
                            <div *ngIf="childitem?.type == 'checkBox'" style="height: 45.93px !important; padding-top: 10px">
                              <mat-checkbox class="automatic-form-checkbox" [formControlName]="childitem?.formControlName">
                                <mat-label class="automtic-form-desing-lable">
                                  {{ childitem.label }}
                                  <span *ngIf="childitem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                                </mat-label>
                              </mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    *ngIf="beneFicaryForm?.length >= 1 && !isRemoveEditSaveSharing && !(mode == 'view')"
                    (click)="addBeneficiarybyform(arrayItem.formControlName, i)"
                    class="add-beneficarybutton"
                  >
                    Add {{ arrayItem.Singularname }}
                  </button>
                </div>
                <div class="flex-container mobile-form-container" style="margin: 0px -20px 0px -20px !important">
                  <div
                    class="dynamic-form-field-container"
                    *ngFor="let arrayItem of showNotesitems; let i = index"
                    [ngStyle]="{ width: arrayItem?.width ? (arrayItem?.width == '99%' ? '100%' : arrayItem?.width) : '100%' }"
                  >
                    <mat-form-field
                      appearance="fill"
                      [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                      style="width: 100% !important; margin-top: 12px"
                      [ngClass]="
                        mode == 'view'
                          ? 'disable-all-input-filed-from'
                          : isGeneralSectionResolve
                          ? 'blue-app__medium--height--form'
                          : 'app__medium--height--form'
                      "
                      class="automtic-form-desing-form-only"
                    >
                      <mat-label class="automtic-form-desing-lable">
                        {{ arrayItem?.label }}
                        <span *ngIf="arrayItem?.isRequired" class="automtic-form-desing-required-sign"> * </span>
                      </mat-label>
                      <textarea
                        matInput
                        [placeholder]="mode == 'view' ? '---' : arrayItem?.placeholder"
                        maxlength="1500"
                        cdkAutosizeMinRows="5"
                        matTextareaAutosize
                        style="overflow: hidden !important; height: auto !important; min-height: 16px !important"
                        formControlName="showNotes"
                        matTextareaAutosize
                      >
                      </textarea>
                      <div class="form-row__description">{{ documentForm.controls['showNotes'].value.length }}/1500</div>
                    </mat-form-field>
                  </div>
                </div>
                <!-- @if(showCopyDataButton && arrayItems?.length){
                <div class="app__common--copy--btn app__centered-item app__form--attribute--title mt-3" (click)="copyDataFromLiveFeeds()">
                  <span> Copy data from {{ buttonDisplayText }} </span>
                </div>
                } -->
              </div>

              <div
                style="display: flex; flex-direction: column"
                [hidden]="loadingAllElement"
                [ngClass]="mode == 'view' ? 'disable-all-input-filed' : 'enable-all-input-filed'"
                class="stepper1margin app__select--text--size"
                *ngIf="(value_field_required || isEstate) && arrayItems?.length"
              >
                <label class="title" *ngIf="!HideAddinationInfo"
                  >Value
                  <span
                    matTooltipPosition="below"
                    matTooltip="The Value field is not encrypted with your premium security key so that we can send you reminders.
        "
                    class="material-icons info-icon-custom"
                    >info</span
                  >
                </label>
                <div class="expiration-container">
                  <mat-form-field
                    appearance="fill"
                    [ngClass]="
                      mode == 'view'
                        ? 'disable-all-input-filed-from'
                        : isGeneralSectionResolve
                        ? 'blue-app__medium--height--form'
                        : 'app__medium--height--form'
                    "
                    class="expiration-form automtic-form-desing-form-only"
                  >
                    <mat-label class="automtic-form-desing-lable"> Currency </mat-label>
                    <mat-select matNativeControl disableOptionCentering formControlName="value_currency">
                      <mat-option [value]="item.cc" class="hide-check-box" *ngFor="let item of currenciesList">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="continer-dollar">
                    <div style="display: flex; flex-direction: row">
                      <div class="doller-left-area">
                        <mat-icon
                          class="doller-left-area-sign"
                          [ngClass]="[
                            documentForm.controls['value_current_currency'].value?.length == 0 ? 'disabel-place' : '',
                            mode == 'view' ? 'disable-doller-left-area' : 'enable-doller-left-area'
                          ]"
                          style="font: inherit !important"
                          matPrefix
                          >{{ currecntCurrecySymbol }}</mat-icon
                        >
                      </div>
                      <input
                        matInput
                        id="targetNumber"
                        placeholder="Current Value"
                        type="text"
                        maxlength="18"
                        onkeyup="javascript:this.value=Comma(this.value);"
                        [ngClass]="mode == 'view' ? 'disable-currency-edior' : 'enable-currency-edior'"
                        formControlName="value_current_currency"
                      />
                    </div>
                  </div>
                  <mat-form-field
                    appearance="fill"
                    [ngClass]="
                      mode == 'view'
                        ? 'disable-all-input-filed-from'
                        : isGeneralSectionResolve
                        ? 'blue-app__medium--height--form'
                        : 'app__medium--height--form'
                    "
                    class="expiration-form dollar-automtic-form-desing-form-only"
                  >
                    <mat-label class="automtic-form-desing-lable"> Has an appraisal been done? </mat-label>
                    <mat-select matNativeControl disableOptionCentering formControlName="value_is_appraisal">
                      <mat-option value="true" class="hide-check-box"> Yes</mat-option>
                      <mat-option value="false" class="hide-check-box"> No</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    appearance="fill"
                    [ngClass]="
                      mode == 'view'
                        ? 'disable-all-input-filed-from'
                        : isGeneralSectionResolve
                        ? 'blue-app__medium--height--form'
                        : 'app__medium--height--form'
                    "
                    class="expiration-form automtic-form-desing-form-only"
                  >
                    <mat-label class="automtic-form-desing-lable"> Last Appraisal Date </mat-label>
                    <input matInput [matDatepicker]="dp7" readonly (click)="mode != 'view' && dp7.open()" formControlName="value_appraisal_date" />
                    <mat-icon
                      matSuffix
                      [style.cursor]="mode == 'view' ? 'default' : 'pointer'"
                      *ngIf="documentForm.controls['value_appraisal_date'].value"
                      (click)="mode != 'view' && documentForm.controls['value_appraisal_date'].reset()"
                      >clear</mat-icon
                    >
                    <mat-datepicker-toggle matSuffix [for]="dp7" [disabled]="mode == 'view'"></mat-datepicker-toggle>
                    <mat-datepicker #dp7 disabled="false"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <!-- <button
              *ngIf="!showAddNoteTextbox && !isRemoveEditSaveSharing && mode != 'view' && documentForm.controls.notes?.value?.length == 0"
              class="add-notes-btn"
              (click)="showAddNoteTextbox = true"
            >
              <img style="position: relative; top: -2px" src="assets/images/add-notes.svg" />
              Add Note
            </button> -->
              <div
                style="display: flex; flex-direction: column; margin: 0% 2.5% 0% 1% !important"
                [hidden]="loadingAllElement"
                [ngClass]="mode == 'view' ? 'disable-all-input-filed' : 'enable-all-input-filed'"
                class="stepper1margin app__select--text--size"
                *ngIf="(arrayItems?.length && showAddNoteTextbox) || documentForm?.controls?.notes?.value?.length"
              >
                <mat-form-field
                  [floatLabel]="mode == 'view' ? 'always' : 'auto'"
                  [ngClass]="
                    mode == 'view'
                      ? 'disable-all-input-filed-from'
                      : isGeneralSectionResolve
                      ? 'blue-app__medium--height--form'
                      : 'app__medium--height--form'
                  "
                  style="width: 100% !important; margin-bottom: 0px"
                  class="automtic-form-desing-form-only"
                >
                  <mat-label class="automtic-form-desing-lable"> Notes </mat-label>
                  <textarea
                    matInput
                    pattern="\d+"
                    maxlength="1500"
                    cdkAutosizeMinRows="5"
                    formControlName="notes"
                    [placeholder]="mode == 'view' ? '---' : 'Enter your notes'"
                    style="overflow: hidden; height: auto !important; min-height: 48px !important; font-size: 14px; color: #707070"
                    matTextareaAutosize
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </form>
            <!-- <form
              [formGroup]="itemsToSetup"
              *ngIf="
                (mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing) ||
                isGeneralSectionResolve ||
                ((arrayItems | generalSectionSaveEdit) &&
                  savedDynamicFieldsFormValueInDb != null &&
                  ((documentForm.controls.dynamicFieldsForm.value | jsonDiff : savedDynamicFieldsFormValueInDb : (arrayItems | findDescriptionTag)) ||
                    (documentForm.controls.beneFicaryForm.value | jsonDiff : saveBeneficiaryFormValueInDb)))
              "
            >
              <div class="flex my-4">
                <mat-slide-toggle
                  formControlName="generalSection"
                  style="color: #25508e; font-family: Open Sans; font-style: normal; font-weight: 600; font-size: 14px"
                  class="array-item-title section-lable margin-zero mb-0 mt-0"
                  (change)="onChange('generalSection')"
                >
                  Mark General Information as Complete
                </mat-slide-toggle>
              </div>
            </form> -->

            }
            <ng-container *ngIf="arrayItems | findDescriptionTag">
              <div class="mt-8 mr-6">
                <label class="app__template--linked--header flex items-center gap-2">
                  Description @if(!descriptionHasAnyValue){
                  <img
                    src="/assets/images/high-priority-flag-icon.svg"
                    matTooltip="High Priority Item"
                    matTooltipPosition="above"
                    alt="High Priority Item"
                  />
                  }
                </label>

                <ngx-editor-field
                  [mode]="mode"
                  [itemsToSetup]="itemsToSetup"
                  [showToggle]="mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing"
                  (parentFun)="parentFun($event)"
                  [saveValueInDb]="
                    savedDynamicFieldsFormValueInDb != null
                      ? savedDynamicFieldsFormValueInDb[0][(arrayItems | findDescriptionTag).formControlName]
                      : null
                  "
                  [requiredSaveEditButton]="!(mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing)"
                  (bookTitleCreated)="onBookAdded($event)"
                  (saveDescription)="saveDescription($event)"
                  [arrayItem]="arrayItems | findDescriptionTag"
                  [formControlValue]="
                    documentForm.controls.dynamicFieldsForm.controls[0].controls[(arrayItems | findDescriptionTag).formControlName].value
                  "
                >
                </ngx-editor-field>
              </div>
            </ng-container>
            <div class="app__template--component--spacing mt-8">
              <ng-container *ngIf="showRightSideSection || (mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing)">
                <capital-commitment-linked-templates
                  [hideManageButton]="hideManageButton"
                  [root_form_type_template]="root_form_type_template"
                  *ngIf="currentFormId && hasCapitalCommitmentLink()"
                  style="margin-right: 24px"
                  [currentuserId]="currentuserId"
                  [formName]="documentForm.controls.documentName.value"
                  [origin]="origin"
                  [enable_linked_exchange_wallets]="enable_linked_exchange_wallets"
                  [show_left]="true"
                  [enable_linked_cryptocurrency]="enable_linked_cryptocurrency"
                  [enable_linked_cryptocurrency_wallets]="enable_linked_cryptocurrency_wallets"
                  [enable_linked_exchange_accounts]="enable_linked_exchange_accounts"
                  [enable_Institution]="enable_Institution"
                  [include_holding]="false"
                  [data]="data"
                  [currentFormId]="currentFormId"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  [formsList]="formsList"
                >
                </capital-commitment-linked-templates>
                <ng-container *ngIf="hasFinancialAttributes()">
                  <add-finacial-attribute
                    [connected_to_institution]="connected_to_institution"
                    [currentFormId]="currentFormId"
                    #childFinacialAttribute
                    (someEvent)="deletePhone($event)"
                    [currentVaultUserId]="currentValutUserId"
                    [mode]="mode"
                    [data]="data"
                    [templateId]="templateId"
                    [selectedFileList]="selectedFileList"
                    [currentuserId]="currentuserId"
                    [name]="documentForm.controls.documentName.value"
                    [fId]="fId"
                    [countList]="countList"
                    [has_death_benefit]="has_death_benefit"
                    [formName]="documentForm.controls.documentName.value"
                    [transaction_register_disabled]="transaction_register_disabled"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    [userId]="currentValutUserId"
                    (passEvent)="getReminderData($event)"
                    (setupItemEmitter)="handleSetupItem($event)"
                    (updateCountList)="updateCountList($event)"
                    (updateApiEmitter)="handleUpdateApiEmitter($event)"
                  >
                  </add-finacial-attribute>
                </ng-container>

                <!-- <br /> -->
                <!-- <add-transaction-attribute
            #childTransactionAttribute
            [connected_to_institution]="connected_to_institution"
            [currentFormId]="currentFormId"
            [currentValutUserId]="currentValutUserId"
            *ngIf="isLocalOrTest"
            [name]="documentForm.controls.documentName.value"
            [mode]="mode"
            [data]="data"
            [currentuserId]="currentuserId"
            [fId]="fId"
            [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
            [userId]="currentValutUserId"
          >
          </add-transaction-attribute> -->
                <!-- <linked-transaction-count
            [currentFormId]="currentFormId"
            *ngIf="isLocalOrTest"
            [mode]="mode"
            [data]="data"
            [name]="documentForm.controls.documentName.value"
            [countList]="countList"
            [currentuserId]="currentuserId"
            [connected_to_institution]="connected_to_institution"
            [fId]="fId"
            [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
            [userId]="currentValutUserId"
            (updateCountListEvent)="updateCountList($event)"
          >
          </linked-transaction-count> -->
                <!-- <add-performance-summary
            #childPerformanceSummary
            [currentValutUserId]="currentValutUserId"
            [currentFormId]="currentFormId"
            [currentuserId]="currentuserId"
            [name]="documentForm.controls.documentName.value"
            [mode]="mode"
            [data]="data"
            [fId]="fId"
            [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
          ></add-performance-summary> -->

                @if(hasInsuranceAttribute()){
                <insurance-attributes
                  #childInsuranceAttribute
                  [currentFormId]="currentFormId"
                  [data]="data"
                  [connected_to_institution]="connected_to_institution"
                  [mode]="mode"
                  [currentuserId]="currentuserId"
                  [name]="documentForm.controls.documentName.value"
                  [fId]="fId"
                  [templateId]="templateId"
                  [countList]="countList"
                  [has_death_benefit]="has_death_benefit"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  [userId]="currentValutUserId"
                  (setupItemEmitter)="handleSetupItem($event)"
                >
                </insurance-attributes>
                } @if(fId != 1 && currentFormId && hasLinkedPositions){
                <linked-ownership-positions
                  [mode]="mode"
                  [data]="data"
                  [origin]="origin"
                  [vaultFormId]="vaultFormId"
                  [currentuserId]="currentuserId"
                  [currentFormId]="currentFormId"
                  [linkedAssetsEnabled]="linkedAssetsEnabled"
                  [linkedEntitiesEnabled]="linkedEntitiesEnabled"
                  [linkedLiabilitiesEnabled]="linkedLiabilitiesEnabled"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  [formName]="documentForm.controls.documentName.value"
                  (linkedPositionSelectionChange)="onLinkedOwnershipPositionSelectionChange($event)"
                >
                </linked-ownership-positions>
                } @if(fId != 1 && currentFormId && (has_owns_assets || has_owns_entities)){
                <role-players-association-card
                  [mode]="mode"
                  [data]="data"
                  [origin]="origin"
                  [currentuserId]="currentuserId"
                  [currentFormId]="currentFormId"
                  [headerText]="'Is the Owner of'"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  [formName]="documentForm.controls.documentName.value"
                  (rolePlayerAssociationSelectionChange)="onRolePlayerAssociationSelectionChange($event)"
                >
                </role-players-association-card>
                } @if(fId != 1 && currentFormId && hasBeneficialOwnership){
                <role-players-association-card
                  [mode]="mode"
                  [data]="data"
                  [origin]="origin"
                  [currentuserId]="currentuserId"
                  [currentFormId]="currentFormId"
                  [headerText]="'Beneficial Ownership'"
                  [isBeneficialOwnership]="true"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  [formName]="documentForm.controls.documentName.value"
                  (rolePlayerAssociationSelectionChange)="onRolePlayerAssociationSelectionChange($event)"
                >
                </role-players-association-card>
                } @if(fId != 1 && currentFormId){
                <non-document-attachment
                  (suggestedDocumentEmitter)="suggestedDocument()"
                  (attachDocumentEmitter)="attachDocument()"
                  (summaryUpdateEmitter)="summaryUpdate()"
                  (documentUpdateEvent)="documentUpdateEvent($event)"
                  [has_document]="has_document"
                  [currentFormId]="currentFormId"
                  [vault_id]="vault_id"
                  [currentuserId]="currentuserId"
                  [shareTypeData]="ShareTypeDataNewFlow"
                  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  [suggested_documents]="suggested_documents"
                  (nonDocumentAttachmentSelectionChange)="onNonDocumentAttachmentSelectionChange($event)"
                ></non-document-attachment>
                } @if(fId != 1 && !isIpadOrTabletScreenWidth()){
                <ng-container *ngTemplateOutlet="notesComponent"></ng-container>
                }

                <div *ngIf="showLocationSection && screenWidth < 480 && !data?.isLinked" class="assiciation-area">
                  <form *ngIf="currentFormId" class="add-document-association-ui">
                    <ng-container *ngIf="showRightSideSection">
                      <h3 class="linked-header mt-5">Action Items</h3>
                      <items-to-set-up
                        *ngIf="currentFormId && Form1.length"
                        [currentUserId]="currentuserId"
                        [sharingMode]="sharingMode"
                        [hideManageButton]="hideManageButton"
                        #ItemsToSetUpAttribute
                        [itemsToSetup]="itemsToSetup"
                        [enable_template_linking_filter]="enable_template_linking_filter"
                        (formStatusEvent)="formStatusEvent($event)"
                        (itemsToSetUpListAttachmentEvent)="itemsToSetUpListAttachmentEvent($event)"
                        (itemsToSetUpListRolePlayersEvent)="rolePlayersItemInSetUpList($event)"
                        (itemsToSetUpListRapidAPIEvent)="itemsToSetUpListRapidAPIEvent($event)"
                        (itemsToSetUpListSharingEvent)="itemsToSetUpListSharingEvent($event)"
                        (itemsToSetUpEvent)="itemsToSetUpAction($event)"
                        (itemsToSetUpListCompleteAllEvent)="itemsToSetUpListCompleteAllEvent($event)"
                        [mode]="mode"
                        [currentFormId]="currentFormId"
                        [formsList]="formsList"
                        [data]="data"
                      >
                      </items-to-set-up>

                      <!-- <add-checklist-task
                      *ngIf="currentFormId"
                      [currentuserId]="currentuserId"
                      [userId]="currentValutUserId ? currentValutUserId : currentuserId"
                      [sharingMode]="sharingMode"
                      (taskUpdateEvent)="updateTaskList($event)"
                      [mode]="mode"
                      [origin]="origin"
                      [currentFormId]="currentFormId"
                    >
                    </add-checklist-task> -->
                      <div *ngIf="formsRolePlayers.length">
                        <role-players-card-in-form
                          #rolePlayersInFormComponent
                          [mode]="mode"
                          [data]="data"
                          [origin]="origin"
                          [formsList]="formsList"
                          [currentuserId]="currentuserId"
                          [currentFormId]="currentFormId"
                          [formsRolePlayers]="formsRolePlayers"
                          [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                          [formName]="documentForm.controls.documentName.value"
                          [templateId]="templateId"
                          [aiIsProcessing]="ai_is_upload_Running"
                          (rolePlayerSelectionChange)="onRolePlayerSelectionChange($event)"
                          (aiSuggestionSelectionChange)="onRolePlayerAISuggestionSelectionChange($event)"
                        ></role-players-card-in-form>
                      </div>

                      <!-- <add-asset-form-association
                      [formName]="documentForm.controls.documentName.value"
                      [sharingMode]="sharingMode"
                      [mode]="mode"
                      [data]="data"
                      #childAssocaite
                      [currentuserId]="currentuserId"
                      [currentValutUserId]="currentValutUserId"
                      *ngIf="has_assets"
                      [origin]="origin"
                      [currentFormId]="currentFormId"
                      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    >
                    </add-asset-form-association>
                    <add-entity-form-association
                      [formName]="documentForm.controls.documentName.value"
                      [sharingMode]="sharingMode"
                      [mode]="mode"
                      [currentValutUserId]="currentValutUserId"
                      [data]="data"
                      #childAssocaite
                      [currentuserId]="currentuserId"
                      *ngIf="has_entity"
                      [origin]="origin"
                      [currentFormId]="currentFormId"
                      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    >
                    </add-entity-form-association> -->
                      <div
                        class="app__template--inner--spacing grid gap-8"
                        [ngClass]="{
                          'w-full m-0': isIpadOrTabletScreenWidth(),
                        }"
                        *ngIf="currentFormId && showLinkedPaymentMethod"
                      >
                        @for(paymentMethodType of paymentMethodTypes; track i; let i = $index) {
                        <app-linked-template-method
                          [data]="data"
                          [root_form_type_template]="root_form_type_template"
                          [formsList]="formsList"
                          [currentFormId]="currentFormId"
                          [currentUserId]="currentuserId"
                          [selectedLinkType]="paymentMethodType"
                          [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                          (linkedTemplateSelectionChange)="onLinkedTemplateMethodSelectionChange($event)"
                        ></app-linked-template-method>
                        }
                      </div>

                      <h3 class="text-lg leading-7" *ngIf="has_item_location || has_password_location || has_location" style="margin: 0pc 5% 16px 5%">
                        Location Tracking
                      </h3>

                      <location-linked-templates
                        *ngIf="currentFormId && has_item_location"
                        [fId]="fId"
                        [hideManageButton]="hideManageButton"
                        [currentuserId]="currentuserId"
                        [origin]="origin"
                        [has_item_location]="has_item_location"
                        [data]="data"
                        [formsList]="formsList"
                        [formName]="documentForm.controls.documentName.value"
                        [currentFormId]="currentFormId"
                        [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                        (itmeSetMark)="itmeSetMark($event)"
                        (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
                      >
                      </location-linked-templates>
                      <location-linked-templates
                        *ngIf="currentFormId && has_location"
                        [fId]="fId"
                        [hideManageButton]="hideManageButton"
                        [currentuserId]="currentuserId"
                        [origin]="origin"
                        [formName]="documentForm.controls.documentName.value"
                        #LocationLinkedTemplatesPhysicalAttribute
                        [data]="data"
                        (itmeSetMark)="itmeSetMark($event)"
                        [currentFormId]="currentFormId"
                        [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                        [formsList]="formsList"
                        (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
                      >
                      </location-linked-templates>
                      <location-linked-templates
                        *ngIf="currentFormId && has_password_location"
                        [fId]="fId"
                        [hideManageButton]="hideManageButton"
                        [currentuserId]="currentuserId"
                        #LocationLinkedTemplatesPasswordAttribute
                        [origin]="origin"
                        [data]="data"
                        [formName]="documentForm.controls.documentName.value"
                        [currentFormId]="currentFormId"
                        (itmeSetMark)="itmeSetMark($event)"
                        [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                        [formsList]="formsList"
                        [enable_physical_location]="true"
                        (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
                      >
                      </location-linked-templates>
                      <!-- <h3 class="linked-header mt-5" *ngIf="has_api_source || has_real_estate_value_estimate || has_api_source_motor">
                        Live Data Feeds
                      </h3>

                      <add-api-rapid-property-value
                        *ngIf="has_real_estate_value_estimate"
                        #AddApiRapidPropertyValueAttribute
                        [currentFormId]="currentFormId"
                        (updateActionItemProperty)="updateActionItemProperty($event)"
                        [mode]="mode"
                        [templateId]="templateId"
                      >
                      </add-api-rapid-property-value>

                      <add-api-rapid-motor-value
                        *ngIf="has_api_source_motor"
                        [mode]="mode"
                        [templateId]="templateId"
                        #AddApiRapidMotorAttribute
                        (updateActionItemVehicle)="updateActionItemVehicle($event)"
                        [currentFormId]="currentFormId"
                      >
                      </add-api-rapid-motor-value>
                      <add-api-key-managed
                        *ngIf="has_api_source"
                        [currentuserId]="currentuserId"
                        [formName]="documentForm.controls.documentName.value"
                        [sharingMode]="sharingMode"
                        [connected_to_institution]="connected_to_institution"
                        [mode]="mode"
                        #AddApiKeyManagedAttribute
                        [data]="data"
                        [origin]="origin"
                        (updateActionItemMx)="updateActionItemMx($event)"
                        (getUpdatedListAPiManager)="getUpdatedListAPiManager($event)"
                        (getNewImageEvent)="getUpdatedImage($event)"
                        [selectedFileList]="selectedFileList"
                        [isDataLoading]="isDataLoading"
                        [currentFormId]="currentFormId"
                        [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                      >
                      </add-api-key-managed> -->

                      @if(!hideManageButton){
                      <div class="absolute left-0 -z-10">
                        <h3 class="linked-header mt-5">Security</h3>
                        <add-security-key
                          [mode]="mode"
                          [data]="data"
                          #childAssocaite
                          [currentuserId]="currentuserId"
                          [origin]="origin"
                          [currentFormId]="currentFormId"
                          [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                          [formName]="documentForm.controls.documentName.value"
                          [isSecurityKeyAdded]="isSecurityKeyAdded"
                          (securityKeyAdded)="isSecurityKeyAddedToTheFom($event)"
                        ></add-security-key>
                      </div>
                      }

                      <reminder-v2
                        (reminderStatusUpdateEvent)="reminderStatusUpdateEvent($event)"
                        *ngIf="currentFormId && Form1.length"
                        [hideManageButton]="hideManageButton"
                        [currentFormId]="currentFormId"
                        [reminderStatus]="reminderStatus"
                        [formValue]="documentForm.value"
                        [currentuserId]="currentuserId"
                        #ReminderV2Attribute
                        [userId]="currentValutUserId"
                        [data]="data"
                        [fId]="fId"
                        [formsList]="formsList"
                        [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                      >
                      </reminder-v2>
                    </ng-container>
                  </form>
                </div>
              </ng-container>
            </div>
          </div>
          @if(isIpadOrTabletScreenWidth()){
          <br />
          <ng-container *ngTemplateOutlet="templateDocumentTagOnly"></ng-container>
          <br />
          <ng-container *ngTemplateOutlet="linkedTemplates"></ng-container>
          <br />
          <ng-container *ngTemplateOutlet="templateDocumentExtraction"></ng-container>
          <br />
          <ng-container *ngTemplateOutlet="notesComponent"></ng-container>
          }
          <manage-activity
            #manageActivityComponent
            [sk]="sk"
            [fId]="fId"
            [files]="files"
            [selectedSecurity_key]="selectedSecurity_key"
            [fileId]="fileId ? fileId : currentFormId"
            *ngIf="currentFormId"
          >
          </manage-activity>
        </div>
        <div
          class="right-area overflow-y-auto"
          [ngClass]="{
            'w-full': isIpadOrTabletScreenWidth()
          }"
          *ngIf="!data?.isLinked && screenWidth >= 480"
          cdkScrollable
        >
          <div *ngIf="showLocationSection" class="assiciation-area">
            <form *ngIf="currentFormId" class="add-document-association-ui app__template--component--spacing">
              <ng-container *ngIf="showRightSideSection">
                <div
                  class="app__template--inner--spacing gap-8 grid"
                  *ngIf="currentFormId && Form1.length"
                  [ngClass]="{
                  'w-full m-0': isIpadOrTabletScreenWidth(),
                }"
                >
                  @if(!isIpadOrTabletScreenWidth()){
                  <ng-container *ngTemplateOutlet="vaultSelectionForm"></ng-container>
                  @if(!isRemoveEditSaveSharing){
                  <ng-container *ngTemplateOutlet="templateTeStatusTemplate"></ng-container>
                  }
                  <ng-container *ngTemplateOutlet="templateDocumentTagOnly"></ng-container>
                  }
                </div>
                <!-- <div class="app__template--inner--spacing">
                  <add-checklist-task
                    *ngIf="currentFormId"
                    [currentuserId]="currentuserId"
                    [userId]="currentValutUserId ? currentValutUserId : currentuserId"
                    [sharingMode]="sharingMode"
                    (taskUpdateEvent)="updateTaskList($event)"
                    [mode]="mode"
                    [origin]="origin"
                    [currentFormId]="currentFormId"
                  >
                  </add-checklist-task>
                </div> -->

                <div class="app__template--inner--spacing" *ngIf="formsRolePlayers.length" [ngClass]="{ 'w-full m-0': isIpadOrTabletScreenWidth() }">
                  <role-players-card-in-form
                    #rolePlayersInFormComponent
                    [mode]="mode"
                    [data]="data"
                    [origin]="origin"
                    [formsList]="formsList"
                    [currentuserId]="currentuserId"
                    [currentFormId]="currentFormId"
                    [formsRolePlayers]="formsRolePlayers"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    [formName]="documentForm.controls.documentName.value"
                    [templateId]="templateId"
                    [aiIsProcessing]="ai_is_upload_Running"
                    (rolePlayerSelectionChange)="onRolePlayerSelectionChange($event)"
                    (aiSuggestionSelectionChange)="onRolePlayerAISuggestionSelectionChange($event)"
                  ></role-players-card-in-form>
                </div>

                <!-- <add-asset-form-association
                    [formName]="documentForm.controls.documentName.value"
                    [sharingMode]="sharingMode"
                    [mode]="mode"
                    [currentValutUserId]="currentValutUserId"
                    [data]="data"
                    #childAssocaite
                    [currentuserId]="currentuserId"
                    *ngIf="has_assets"
                    [origin]="origin"
                    [currentFormId]="currentFormId"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  >
                  </add-asset-form-association>
                  <add-entity-form-association
                    [formName]="documentForm.controls.documentName.value"
                    [sharingMode]="sharingMode"
                    [mode]="mode"
                    [currentValutUserId]="currentValutUserId"
                    [data]="data"
                    #childAssocaite
                    [currentuserId]="currentuserId"
                    *ngIf="has_entity"
                    [origin]="origin"
                    [currentFormId]="currentFormId"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  >
                  </add-entity-form-association> -->
                <div
                  class="app__template--inner--spacing"
                  *ngIf="currentFormId && Form1.length && fId != 1"
                  [ngClass]="{
                    'w-full m-0': isIpadOrTabletScreenWidth(),
                  }"
                >
                  <reminder-v2
                    (reminderStatusUpdateEvent)="reminderStatusUpdateEvent($event)"
                    [hideManageButton]="hideManageButton"
                    [currentFormId]="currentFormId"
                    [formValue]="documentForm.value"
                    [reminderStatus]="reminderStatus"
                    [currentuserId]="currentuserId"
                    [userId]="currentValutUserId"
                    #ReminderV2Attribute
                    [data]="data"
                    [fId]="fId"
                    [formsList]="formsList"
                    [templateData]="templateData"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  >
                  </reminder-v2>
                </div>
                @if(!isIpadOrTabletScreenWidth()){
                <ng-container *ngTemplateOutlet="linkedTemplates"></ng-container>
                <ng-container *ngTemplateOutlet="templateDocumentExtraction"></ng-container>
                }
                <div
                  class="app__template--inner--spacing grid gap-8"
                  [ngClass]="{
                    'w-full m-0': isIpadOrTabletScreenWidth(),
                  }"
                  *ngIf="currentFormId && showLinkedPaymentMethod"
                >
                  @for(paymentMethodType of paymentMethodTypes; track i; let i = $index) {
                  <app-linked-template-method
                    [data]="data"
                    [root_form_type_template]="root_form_type_template"
                    [formsList]="formsList"
                    [currentFormId]="currentFormId"
                    [currentUserId]="currentuserId"
                    [selectedLinkType]="paymentMethodType"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    (linkedTemplateSelectionChange)="onLinkedTemplateMethodSelectionChange($event)"
                  ></app-linked-template-method>
                  }
                </div>
                <div
                  class="app__template--inner--spacing"
                  *ngIf="has_item_location || has_password_location || has_location"
                  [ngClass]="{ 'w-full m-0': isIpadOrTabletScreenWidth() }"
                >
                  <h3 class="app__template--linked--header">Location Tracking</h3>
                  <div style="margin-bottom: 12px">
                    <location-linked-templates
                      *ngIf="currentFormId && has_item_location"
                      [fId]="fId"
                      [hideManageButton]="hideManageButton"
                      [currentuserId]="currentuserId"
                      [origin]="origin"
                      [formName]="documentForm.controls.documentName.value"
                      [has_item_location]="has_item_location"
                      [data]="data"
                      [currentFormId]="currentFormId"
                      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                      [formsList]="formsList"
                      (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
                    >
                    </location-linked-templates>
                  </div>

                  <location-linked-templates
                    *ngIf="currentFormId && has_location"
                    [fId]="fId"
                    [hideManageButton]="hideManageButton"
                    (itmeSetMark)="itmeSetMark($event)"
                    [currentuserId]="currentuserId"
                    [formName]="documentForm.controls.documentName.value"
                    [origin]="origin"
                    #LocationLinkedTemplatesPhysicalAttribute
                    [data]="data"
                    [currentFormId]="currentFormId"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    [formsList]="formsList"
                    (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
                  >
                  </location-linked-templates>
                  <location-linked-templates
                    *ngIf="currentFormId && has_password_location"
                    [fId]="fId"
                    [hideManageButton]="hideManageButton"
                    [currentuserId]="currentuserId"
                    (itmeSetMark)="itmeSetMark($event)"
                    [formName]="documentForm.controls.documentName.value"
                    [origin]="origin"
                    [data]="data"
                    #LocationLinkedTemplatesPasswordAttribute
                    [currentFormId]="currentFormId"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    [formsList]="formsList"
                    [enable_physical_location]="true"
                    (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
                  >
                  </location-linked-templates>
                </div>

                <!-- <div
                  class="app__template--inner--spacing"
                  *ngIf="has_api_source || has_real_estate_value_estimate || has_api_source_motor || hasAttributeApiCall"
                  [ngClass]="{
                  'w-full m-0': isIpadOrTabletScreenWidth(),
                }"
                > -->
                <!-- <h3 class="app__template--linked--header">Live Data Feeds</h3>
                  <add-api-rapid-property-value
                    *ngIf="has_real_estate_value_estimate"
                    [currentFormId]="currentFormId"
                    #AddApiRapidPropertyValueAttribute
                    [mode]="mode"
                    [templateId]="templateId"
                    [rapidAPISetupData]="rapidAPISetupData"
                    (updateActionItemProperty)="updateActionItemProperty($event)"
                  >
                  </add-api-rapid-property-value>

                  <add-api-rapid-motor-value
                    *ngIf="has_api_source_motor"
                    [currentFormId]="currentFormId"
                    #AddApiRapidMotorAttribute
                    [mode]="mode"
                    [templateId]="templateId"
                    [rapidAPISetupData]="rapidAPISetupData"
                    (updateActionItemVehicle)="updateActionItemVehicle($event)"
                  >
                  </add-api-rapid-motor-value>

                  <add-api-key-managed
                    *ngIf="has_api_source"
                    [currentuserId]="currentuserId"
                    [formName]="documentForm.controls.documentName.value"
                    [sharingMode]="sharingMode"
                    [connected_to_institution]="connected_to_institution"
                    [mode]="mode"
                    #AddApiKeyManagedAttribute
                    [data]="data"
                    [origin]="origin"
                    (getNewImageEvent)="getUpdatedImage($event)"
                    (updateActionItemMx)="updateActionItemMx($event)"
                    (getUpdatedListAPiManager)="getUpdatedListAPiManager($event)"
                    [selectedFileList]="selectedFileList"
                    [isDataLoading]="isDataLoading"
                    [currentFormId]="currentFormId"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                  >
                  </add-api-key-managed> -->
                <!-- </div> -->
                @if(fId && fId==1 && !isIpadOrTabletScreenWidth()){
                <div [ngStyle]="{ 'margin-left': '6%' }">
                  <ng-container *ngTemplateOutlet="notesComponent"></ng-container>
                </div>
                } @if(!hideManageButton){
                <div
                  class="app__template--inner--spacing"
                  [ngClass]="{
                  'w-full m-0 relative': isIpadOrTabletScreenWidth(),
                   'absolute left-0 -z-10': !isIpadOrTabletScreenWidth(),
                }"
                >
                  <h3 class="app__template--linked--header">Security</h3>
                  <add-security-key
                    [mode]="mode"
                    [sk]="security_key?.sk"
                    [data]="data"
                    #childAssocaite
                    [currentuserId]="currentuserId"
                    [formName]="documentForm.controls.documentName.value"
                    [origin]="origin"
                    [currentFormId]="currentFormId"
                    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
                    [isSecurityKeyAdded]="isSecurityKeyAdded"
                    (securityKeyAdded)="isSecurityKeyAddedToTheFom($event)"
                  ></add-security-key>
                </div>
                }
              </ng-container>

              <ng-container *ngIf="!showRightSideSection">
                <div class="ph-col-12" *ngFor="let item of loaderItems" style="padding: 0px !important; margin: 12px 0 0 6%">
                  <div class="ph-row">
                    <div class="ph-col-12 height-12"></div>
                    <div class="ph-col-12 height-12"></div>
                  </div>
                </div>
              </ng-container>
              <div
                class="app__template--inner--spacing mb-0 py-6 px-[17px] bg-white border border-[#d3dce8] rounded-lg flex flex-col items-start justify-center min-h-[80px]"
                *ngIf="setupFormTags?.length > 0 && fId != 1"
                [ngClass]="{
                  'w-full m-0': isIpadOrTabletScreenWidth(),
                }"
              >
                <h1 class="text-base font-bold m-0">Template Tags</h1>
                <div class="flex mt-3 gap-2">
                  <ng-container *ngFor="let tag of setupFormTags">
                    <span
                      class="rounded-[4px] border border-[#75a3dd] bg-[#F7FAFF] font-normal text-xs py-[5.5px] px-[10px] gap-1 items-center justify-center text-[#5475c0]"
                      *ngIf="tag.tag"
                    >
                      <img src="assets/images/floral-light.svg" alt="" class="w-4 h-4" />
                      {{ tag.tag }}
                    </span>
                  </ng-container>
                </div>
              </div>

              <div
                *ngIf="ScanFileList && ScanFileList.length > 0"
                class="app__template--inner--spacing mb-0 py-6 px-[17px] bg-white border border-[#d3dce8] rounded-lg flex flex-col items-start justify-center min-h-[80px]"
                [ngClass]="{
                  'w-full m-0': isIpadOrTabletScreenWidth(),
                }"
              >
                <h1 class="text-base font-bold m-0">Word Cloud</h1>
                <div class="flex flex-wrap mt-3 gap-2">
                  <ng-container *ngFor="let inboxItem of ScanFileList">
                    <span
                      class="rounded-[4px] border border-[#75a3dd] bg-[#F7FAFF] font-normal text-xs py-[5.5px] px-[10px] gap-1 items-center justify-center text-[#5475c0]"
                    >
                      {{ inboxItem }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </form>
          </div>
          <div
            #sslEncryptionBadge
            [ngClass]="{
              'mb-18 flex flex-col': isIpadOrTabletScreenWidth(),
              'flex flex-col ml-[6%]': !isIpadOrTabletScreenWidth()
            }"
          >
            <div class="bedge-container w-full" style="display: flex">
              <div style="display: flex">
                <img mat-raised-button class="bedge-image" src="assets/images/create-bedge.svg" />
                <p class="ssl-text">
                  Your data is secured by a
                  <strong> 256bit SSL Encryption </strong>
                </p>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="data?.isLinked" class="footer-linked-container">
        <add-document-save-dropdown
          *ngIf="!LocationEnable"
          [showInformationtabFolderList]="showInformationtabFolderList"
          [data]="data"
          [hideForloderSelection]="hideForloderSelection"
          [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
          [isOficeWorkSpace]="isOficeWorkSpace"
          [currectMyInformationList]="currectMyInformationList"
          [showEstateList]="showEstateList"
          [fullMyInformationList]="fullMyInformationList"
          [showEstateChildList]="showEstateChildList"
          [showESubstateChildList]="showESubstateChildList"
          [selectSaveFolder]="documentForm.controls['selectSaveFolder'].value"
          [selectOfficeSaveFolder]="documentForm.controls['selectOfficeSaveFolder'].value"
          [isInformationWorkSpace]="isInformationWorkSpace"
          [folderList]="folderList"
          [showFolderList]="showFolderList"
          [subfolderList]="subfolderList"
          [selectedParentLable]="selectedParentLable"
          [fullSubFolderList]="fullSubFolderList"
          [documentForm]="documentForm"
          [EsateList]="EsateList"
          [fulassetList]="fulassetList"
          [showEstateList]="showEstateList"
          [fullOfficeFolderList]="fullOfficeFolderList"
          [markSelectOfficeWorspaceDisable]="markSelectOfficeWorspaceDisable"
          [subchildfolderList]="subchildfolderList"
          [officefolderList]="officefolderList"
          [officesubfolderList]="officesubfolderList"
          [mode]="mode"
        ></add-document-save-dropdown>
        <button
          mat-raised-button
          [class.disable-button-continue]="
            (isOficeWorkSpace
              ? !documentForm.controls.selectOfficeSaveFolder.valid
              : parent_vault_user_location_id
              ? false
              : !documentForm.controls.selectSaveFolder.valid) ||
            !documentForm.controls.documentName.valid ||
            disablesingleFielFormValidator ||
            documentForm.controls.selectSaveFolder.value == 1
          "
          *ngIf="mode != 'edit' && mode != 'view' && !isRemoveEditSaveSharing"
          (click)="checkValue(documentForm.value)"
          class="save-continue-button"
          style="top: -5px"
        >
          Create & Link
        </button>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- @if(currentFormId){
<chat-widget-template
  [vault_user_form_id]="currentFormId"
  [templateType]="templateType"
  [currentFormName]="currentFormName"
  [form_id]="fId"
  [formId]="data?.form_id"
  [forms]="forms"
  [files]="documentFiles$ | async"
></chat-widget-template>
} -->

<sealed-file-popup
  *ngIf="isFormSealed"
  [ShareTypeDataNewFlow]="ShareTypeDataNewFlow"
  [formName]="documentForm.controls.documentName.value"
></sealed-file-popup>

<ng-template #vaultSelectionForm>
  @if(analyzeWithAi){
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-6 big"></div>
        <div class="ph-col-4 empty big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-4"></div>
        <div class="ph-col-8 empty"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-6"></div>
        <div class="ph-col-6 empty"></div>
      </div>
    </div>
  </div>
  }@else{ @if(!vault_id && currentFormId && !nonVaultOrganizations.includes(currentTemplate?.organization_section)){ @if(fId == 1 && files.length){
  <vault-selection-form
    [vaultStateObject]="vaultStateObject"
    [vault_list]="vault_list"
    [files]="files[0]"
    [currentuserId]="currentuserId"
    [currentFormId]="currentFormId"
    (vaultSelected)="vaultSelected($event)"
  ></vault-selection-form>
  }@else{
  <vault-selection-form
    [vaultStateObject]="vaultStateObject"
    [vault_list]="vault_list"
    [currentuserId]="currentuserId"
    [currentFormId]="currentFormId"
    (vaultSelected)="vaultSelected($event)"
  ></vault-selection-form>
  } } }
</ng-template>

<ng-template #notesComponent>
  <notes-component
    [data]="data"
    [securityStateObject]="securityStateObject"
    [sharingMode]="sharingMode"
    [currentFormId]="currentFormId"
    [selectedSecurity_key]="selectedSecurity_key"
    [currentuserId]="currentuserId"
    [mode]="mode"
    [fId]="fId"
    [itemsToSetUpList]="itemsToSetUp?.itemsToSetUpList"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    *ngIf="currentFormId && securityStateObject"
  ></notes-component>
</ng-template>

<ng-template #linkedTemplates>
  <div class="app__template--inner--spacing" [ngClass]="{ 'w-full m-0': isIpadOrTabletScreenWidth() }">
    @if(fId == 1){
    <document-linking-template
      #documentLinkingTemplate
      *ngIf="currentFormId"
      [currentFormId]="currentFormId"
      [categories]="categories"
      [currentuserId]="currentuserId"
      [fId]="fId"
      [showButton]="!hideSharedAndMoreVertBtn && !(data?.isintelligent == true || data?.mode == 'add')"
      [formsList]="formsList"
      (aiFetchDocumentEvent)="aiFetchDocumentEvent($event)"
      (aiRunningEvent)="aiRunningEvent($event)"
      (vaultSelectionUpdateEvent)="vaultSelectionUpdateEvent($event)"
      (linkedFormsUpdated)="onLinkedFormsUpdated()"
      (documentLinkedTemplateSelectionChange)="onDocumentLinkedTemplateSelectionChange($event)"
      [formName]="documentForm.controls.documentName.value"
      [hideManageButton]="hideManageButton"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    ></document-linking-template>
    <document-linking-template-create
      *ngIf="currentFormId"
      [currentFormId]="currentFormId"
      [categories]="categories"
      [currentuserId]="currentuserId"
      [fId]="fId"
      [showButton]="!hideSharedAndMoreVertBtn && !(data?.isintelligent == true || data?.mode == 'add')"
      [formsList]="formsList"
      (aiFetchDocumentEvent)="aiFetchDocumentEvent($event)"
      (aiRunningEvent)="aiRunningEvent($event)"
      (linkedFormsUpdated)="onLinkedFormsUpdated()"
      [formName]="documentForm.controls.documentName.value"
      [hideManageButton]="hideManageButton"
    ></document-linking-template-create>

    }@else{
    <non-document-linking-template
      #nonDocumentLinkingTemplate
      *ngIf="currentFormId && fId && formsList"
      [currentFormId]="currentFormId"
      [fId]="fId"
      [isDocumentLinking]="false"
      [categories]="categories"
      [currentuserId]="currentuserId"
      [showButton]="!hideSharedAndMoreVertBtn && !(data?.isintelligent == true || data?.mode == 'add')"
      [formsList]="formsList"
      (aiFetchDocumentEvent)="aiFetchDocumentEvent($event)"
      (aiRunningEvent)="aiRunningEvent($event)"
      (vaultSelectionUpdateEvent)="vaultSelectionUpdateEvent($event)"
      (linkedFormsUpdated)="onLinkedFormsUpdated()"
      (nonDocumentlinkingTemplateSelectionChange)="onNonDocumentLinkedTemplateSelectionChange($event)"
      (suggestionSelectionChange)="onNonDocumentSuggestionSelectionChange($event)"
      (templateSuggestionSelectionChange)="onNonDocumentTemplateSuggestionSelectionChange($event)"
      [formName]="documentForm.controls.documentName.value"
      [hideManageButton]="hideManageButton"
      [ignore_ai_suggestion]="ignore_ai_suggestion"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    ></non-document-linking-template>

    }
  </div>
</ng-template>
<ng-template #templateDocumentTag>
  @if(fId == 1 && currentFormId){ @if(isTemplateDocumentTagLoading){
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-6 big"></div>
        <div class="ph-col-4 empty big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-4"></div>
        <div class="ph-col-8 empty"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-6"></div>
        <div class="ph-col-6 empty"></div>
      </div>
    </div>
  </div>
  } @else {
  <template-document-tag
    [files]="files"
    [currentFormId]="currentFormId"
    [currentFolderId]="currentFolderId"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    (attachmentTagsEvent)="getfileliseForCurrentForms()"
  >
  </template-document-tag>
  <div class="app__template--inner--spacing" [ngClass]="{ 'w-full m-0': isIpadOrTabletScreenWidth() }">
    <document-template-extraction
      [currentFormId]="currentFormId"
      [categories]="categories"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
      (multiItemExtractionCategoriesEvent)="multiItemExtractionCategoriesEvent($event)"
      (openDataExtractionSideNav)="openDataExtractionSideNav($event)"
    >
    </document-template-extraction>
  </div>
  } }
</ng-template>
<ng-template #templateDocumentTagOnly>
  @if(fId == 1 && currentFormId){ @if(isTemplateDocumentTagLoading){
  <div class="ph-item">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-6 big"></div>
        <div class="ph-col-4 empty big"></div>
        <div class="ph-col-2 big"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-4"></div>
        <div class="ph-col-8 empty"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-6"></div>
        <div class="ph-col-6 empty"></div>
      </div>
    </div>
  </div>
  } @else {
  <template-document-tag
    #templateDocumentTagRef
    [files]="files"
    [currentFormId]="currentFormId"
    [currentFolderId]="currentFolderId"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    (attachmentTagsEvent)="getfileliseForCurrentForms()"
    (tagSelectionChange)="onTagSelectionChange($event)"
  >
  </template-document-tag>
  } }
</ng-template>
<ng-template #templateDocumentExtraction>
  @if(fId == 1 && currentFormId){
  <div
    class="app__template--inner--spacing"
    [ngClass]="{
      'w-full m-0': isIpadOrTabletScreenWidth(),
    }"
  >
    @if(isTemplateDocumentTagLoading){
    <div class="ph-item">
      <div class="ph-col-12">
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-2 big"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4"></div>
          <div class="ph-col-8 empty"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-6"></div>
          <div class="ph-col-6 empty"></div>
        </div>
      </div>
    </div>
    } @else {
    <document-template-extraction
      [currentFormId]="currentFormId"
      [categories]="categories"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
      (multiItemExtractionCategoriesEvent)="multiItemExtractionCategoriesEvent($event)"
      (openDataExtractionSideNav)="openDataExtractionSideNav($event)"
    >
    </document-template-extraction>
    }
  </div>
  }
</ng-template>
<ng-template #itemsToSetUpComponent>
  <!-- @if(fId != 1 ){
  <items-to-set-up
    *ngIf="currentFormId && Form1.length"
    [currentuserId]="currentuserId"
    [hideManageButton]="hideManageButton"
    [sharingMode]="sharingMode"
    [itemsToSetup]="itemsToSetup"
    #ItemsToSetUpAttribute
    [mode]="mode"
    [enable_template_linking_filter]="enable_template_linking_filter"
    (formStatusEvent)="formStatusEvent($event)"
    (itemsToSetUpListAttachmentEvent)="itemsToSetUpListAttachmentEvent($event)"
    (itemsToSetUpListRolePlayersEvent)="rolePlayersItemInSetUpList($event)"
    (itemsToSetUpListRapidAPIEvent)="itemsToSetUpListRapidAPIEvent($event)"
    (itemsToSetUpListSharingEvent)="itemsToSetUpListSharingEvent($event)"
    (itemsToSetUpEvent)="itemsToSetUpAction($event)"
    (itemsToSetUpListCompleteAllEvent)="itemsToSetUpListCompleteAllEvent($event)"
    [currentFormId]="currentFormId"
    [formsList]="formsList"
    [data]="data"
  >
  </items-to-set-up>
  } -->
</ng-template>

<ng-template #templateTeStatusTemplate>
  <div class="flex justify-between items-center border rounded-lg p-4 bg-white border-[#D3DCE8] w-full">
    <P class="m-0 font-bold text-base">Template Status</P>
    <span
      (click)="handleStatusMenu($event)"
      [matMenuTriggerFor]="statusMenu"
      class="text-sm font-bold rounded w-[174px] h-10 flex items-center cursor-pointer px-4 relative justify-between"
      [ngClass]="{
        'text-[#828282] bg-[#EBEBEB]': isTemplateStatus('notStarted'),
        'text-[#2D9CDB] bg-[#EAF5FB]': isTemplateStatus('workingOnIt'),
        'text-[#F2994A] bg-[#FFF2CD]': isTemplateStatus('review'),
        'text-[#EB5757] bg-[#FAE0E4]': isTemplateStatus('needsAttention'),
        'text-[#1AA140] bg-[#E9F7EF]': isTemplateStatus('complete')
      }"
    >
      <!-- @if(templateTypeToBeUpdated === 'complete'){
      <span class="material-icons text-[#1AA140] w-5 h-5 material-symbols-outlined font-bold rotate-90"> progress_activity </span>
      <img src="/assets/gif/confetti-3.gif" alt="" class="w-full absolute z-10" />
      } @else{ -->
      {{ getTemplateStatusLabel(templateData?.template_status) }}
      <span class="material-icons material-icons-round text-[#898F9E]">keyboard_arrow_down</span>
      <!-- } -->
    </span>

    <mat-menu
      #statusMenu="matMenu"
      yPosition="below"
      xPosition="after"
      class="popup-menu-panel popup-menu-panel-status statusMenu app__mat-menu-panel"
      id="statusMenu"
      style="padding: 0 20px"
    >
      @for (status of templateStatuses; track status;) {
      <button
        [ngClass]="getStatusMenuItemClass(status.status)"
        mat-menu-item
        class="popup-menu-item flex items-center cursor-pointer"
        (click)="handleTemplateStatusChange(status.status, templateData)"
      >
        <span class="app__menu-item-text">{{ status.type }}</span>
      </button>
      }
    </mat-menu>
  </div>
</ng-template>

@if (selectedItemsArray?.length >= 1) {
<app-common-floater-action
  class="fixed bottom-7 left-[50%] translate-x-[-50%] w-full max-w-[400px] z-[9999]"
  [removeButtonText]="'Remove'"
  [selectedItemsArray]="selectedItemsArray"
  (onMoveClicked)="floaterActionHandler($event)"
></app-common-floater-action>
}
